import commonObj from "../../services/common.js";
var common = new commonObj();
export default {
  Lbl: {
    masterMaintenance: common.getLocalizedString(
      "LBL",
      "lbl_MasterMaintenance"
    ), // Master Maintenance
    country: common.getLocalizedString("LBL", "lbl_Country"), // Country
    city: common.getLocalizedString("LBL", "lbl_City"), // City
    all: common.getLocalizedString("LBL", "lbl_All"), // All
    accountI: common.getLocalizedString("LBL", "lbl_AI"), // All
    file: common.getLocalizedString("LBL", "lbl_File"), // File
    UDB: common.getLocalizedString("LBL", "lbl_UDB"), // File
    SQL: common.getLocalizedString("LBL", "lbl_SQL"), // File
    countryCode: common.getLocalizedString("LBL", "lbl_CountryCode"), // Country code
    countryNameTitle: common.getLocalizedString("LBL", "lbl_CountryNameTitle"), // Country Name
    iDDTitle: common.getLocalizedString("LBL", "lbl_IDDTitle"), // IDD
    curCodeTitle: common.getLocalizedString("LBL", "lbl_CurCodeTitle"), // Currency Code
    curCode: common.getLocalizedString("LBL", "lbl_CurCodeTitle"), // Currency Code为了配合后端返回数据 2023-09-23
    reportTitle: common.getLocalizedString("LBL", "lbl_ReportTitle"), // Report ID
    reportEngDesc: common.getLocalizedString("LBL", "lbl_ReportEngDesc"), // Report Eng Desc
    reportChiDesc: common.getLocalizedString("LBL", "lbl_ReportChiDesc"), // Report Chi Desc
    chooseFile: common.getLocalizedString("LBL", "lbl_ChooseFile"), // Choose file
    import: common.getLocalizedString("LBL", "lbl_Import"), // Import
    keyword: common.getLocalizedString("LBL", "lbl_Keyword"), // Keyword
    warning: common.getLocalizedString("LBL", "lbl_Warning"), // Warning
    ok: common.getLocalizedString("LBL", "lbl_Ok"), // Ok
    district: common.getLocalizedString("LBL", "lbl_District"), // District
    districtCode: common.getLocalizedString("LBL", "lbl_DistrictCode"), // District Code
    areaCode: common.getLocalizedString("LBL", "lbl_AreaCode"), // Area Code
    areaDescTitle: common.getLocalizedString("LBL", "lbl_AreaDescTitle"), // Area Discription
    areaChiDescTitle: common.getLocalizedString("LBL", "lbl_AreaChiDescTitle"), // Area Chinese Discription
    dashboard: common.getLocalizedString("LBL", "lbl_Dashboard"), // Dashboard
    brand: common.getLocalizedString("LBL", "lbl_Brand"), // Brand
    brandCode: common.getLocalizedString("LBL", "lbl_BrandCodeTitle"), //Brand Code
    brandDesc: common.getLocalizedString("LBL", "lbl_BrandDescTitle"), //Brand Description
    chineseDescription: common.getLocalizedString(
      "LBL",
      "lbl_ChineseDescTitle"
    ), // Chinese Description
    cate1: common.getLocalizedString("LBL", "lbl_Cate1"), // Category 1
    cate2: common.getLocalizedString("LBL", "lbl_Cate2"), // Category 2
    series: common.getLocalizedString("LBL", "lbl_Series"), //Series
    engDescTitle: common.getLocalizedString("LBL", "lbl_EngDescTitle"), //English Description
    eDesc: common.getLocalizedString("LBL", "lbl_EngDescTitle"), //English Description 为了配合后端返回数据 2023-09-23
    cate2Code: common.getLocalizedString("LBL", "lbl_Cate2Code"), // Category 2 code
    cate1Code: common.getLocalizedString("LBL", "lbl_Cate1Code"), // Category 1 Code
    cate1Disc: common.getLocalizedString("LBL", "lbl_Cate1Disc"), // Category 1 Discount
    indDisc: common.getLocalizedString("LBL", "lbl_IndDisc"), // Category 1 Ind Discount
    salesmanGroup: common.getLocalizedString("LBL", "lbl_SalesmanGroup"), // Salesman Group
    refGrp1: common.getLocalizedString("LBL", "lbl_RefGrp1"), // Category 1 Reference group 1
    refGrp2: common.getLocalizedString("LBL", "lbl_RefGrp2"), // Category 1 Reference group 2
    cate1_MarkUp: common.getLocalizedString("LBL", "lbl_Cate1_MarkUp"), // Category 1 Mark up
    chiAdd1: common.getLocalizedString("LBL", "lbl_ChiAdd1"), // Chinese Address 1
    chiAdd2: common.getLocalizedString("LBL", "lbl_ChiAdd2"), // Chinese Address 2
    chiAdd3: common.getLocalizedString("LBL", "lbl_ChiAdd3"), // Chinese Address 3
    chiAdd4: common.getLocalizedString("LBL", "lbl_ChiAdd4"), // Chinese Address 4
    paymentTermCode: common.getLocalizedString("LBL", "lbl_PaymentTermCode"), // Term Code
    countFrom: common.getLocalizedString("LBL", "lbl_CountFrom"), // Count From
    retail_TradeDiscount: common.getLocalizedString(
      "LBL",
      "lbl_Retail_TradeDiscount"
    ), // Retail Trade Discount
    vendor_TradeDiscount: common.getLocalizedString(
      "LBL",
      "lbl_Vendor_TradeDiscount"
    ), // Vendor Trade Discount
    prePaid: common.getLocalizedString("LBL", "lbl_PrePaid"), // Pre Paid
    pxClsCode: common.getLocalizedString("LBL", "lbl_PxClsCode"), // Price Class Code
    remCode: common.getLocalizedString("LBL", "lbl_RemCode"), // Remark Code
    lastModifiedBy: common.getLocalizedString("LBL", "lbl_LastModifiedBy"), // Last Modified by
    stockSetting: common.getLocalizedString("LBL", "lbl_StockSetting"), // Stock Setting
    enDesc: common.getLocalizedString("LBL", "lbl_EnDesc"), // EN Description
    tcDesc: common.getLocalizedString("LBL", "lbl_TcDesc"), // TC Description
    scDesc: common.getLocalizedString("LBL", "lbl_SCDesc"), // SC Description
    dateLstRec: common.getLocalizedString("LBL", "lbl_DateLstRec"), // Last Receive Date
    bin1: common.getLocalizedString("LBL", "lbl_Bin1"), // Bin 1
    bin2: common.getLocalizedString("LBL", "lbl_Bin2"), // Bin 2
    withExpiryDate: common.getLocalizedString("LBL", "lbl_WithExpiryDate"), // With Expiry Date
    UDF1: common.getLocalizedString("LBL", "lbl_UDF1"), // User Defined Properties 1
    UDF2: common.getLocalizedString("LBL", "lbl_UDF2"), // User Defined Properties 2
    UDF3: common.getLocalizedString("LBL", "lbl_UDF3"), // User Defined Properties 3
    UDF4: common.getLocalizedString("LBL", "lbl_UDF4"), // User Defined Properties 4
    UDF5: common.getLocalizedString("LBL", "lbl_UDF5"), // User Defined Properties 5
    UDF6: common.getLocalizedString("LBL", "lbl_UDF6"), // User Defined Properties 6
    UDF7: common.getLocalizedString("LBL", "lbl_UDF7"), // User Defined Properties 7
    UDF8: common.getLocalizedString("LBL", "lbl_UDF8"), // User Defined Properties 8
    UDF9: common.getLocalizedString("LBL", "lbl_UDF9"), // User Defined Properties 9
    UDF10: common.getLocalizedString("LBL", "lbl_UDF10"), // User Defined Properties 10
    reference: common.getLocalizedString("LBL", "lbl_Reference"), // Reference
    expDelyDate: common.getLocalizedString("LBL", "lbl_ExpDelyDate"), // Exp. Dely Date
    curr: common.getLocalizedString("LBL", "lbl_Curr"), // Curr
    dateAdd: common.getLocalizedString("LBL", "lbl_DateAdd"), // Date Add
    entItmNum: common.getLocalizedString("LBL", "lbl_EntItmNum"), // Entity Item Number
    EntItmName: common.getLocalizedString("LBL", "lbl_EntItmName"), // Entity Item Name货品名称
    label: common.getLocalizedString("LBL", "lbl_Label"), // Label
    dateConsignSince: common.getLocalizedString("LBL", "lbl_DateConsignSince"), // Date Consign Since
    volum: common.getLocalizedString("LBL", "lbl_Volum"), // Vol
    orderUnitQty: common.getLocalizedString("LBL", "lbl_OrderUnitQty"), // Order Unit Qty
    avgCost: common.getLocalizedString("LBL", "lbl_AvgCost"), // Avg. Cost
    department: common.getLocalizedString("LBL", "lbl_Department"), // Department
    deptCodeTitle: common.getLocalizedString("LBL", "lbl_DeptCodeTitle"), // Department Code
    deptNameTitle: common.getLocalizedString("LBL", "lbl_DeptNameTitle"), // Department Name
    binTitle: common.getLocalizedString("LBL", "lbl_BinTitle"), // Bin
    binSeq: common.getLocalizedString("LBL", "lbl_BinSeqTitle"), // Bin Sequence
    binNum: common.getLocalizedString("LBL", "lbl_BinNumTitle"), // Bin number
    binDescription: common.getLocalizedString("LBL", "lbl_BinDescTitle"), // Bin description
    MOQ: common.getLocalizedString("LBL", "lbl_MOQ"), // MOQ
    COQ: common.getLocalizedString("LBL", "lbl_COQ"), // COQ
    idleAlw: common.getLocalizedString("LBL", "lbl_IdleAlw"), // Idle Allow
    minCharge: common.getLocalizedString("LBL", "lbl_MinCharge"), // Minimum Charge
    location: common.getLocalizedString("LBL", "lbl_StkTakeLoc"), // Location
    locTypeTitle: common.getLocalizedString("LBL", "lbl_LocTypeTitle"), // Location Type
    locDesc: common.getLocalizedString("LBL", "Loc.LocDesc"), // Location Description
    EAdd1Title: common.getLocalizedString("LBL", "lbl_EAdd1Title"), // Location Address 1
    EAdd2Title: common.getLocalizedString("LBL", "lbl_EAdd2Title"), // Location Address 2
    EAdd3Title: common.getLocalizedString("LBL", "lbl_EAdd3Title"), // Location Address 3
    EAdd4Title: common.getLocalizedString("LBL", "lbl_EAdd4Title"), // Location Address 4
    phoneNum: common.getLocalizedString("LBL", "lbl_PhoneNumTitle"), // Phone Number
    faxNum: common.getLocalizedString("LBL", "lbl_FaxNumTitle"), // Fax Number
    contactPerson: common.getLocalizedString("LBL", "lbl_ContactPerson"), // Contact person
    area: common.getLocalizedString("LBL", "lbl_AreaLabel"), // Area
    dateClosed: common.getLocalizedString("LBL", "lbl_DateClosedTitle"), // DateClosed
    dateOpen: common.getLocalizedString("LBL", "lbl_DateOpenTitle"), // DateOpen
    locTypeDesc: common.getLocalizedString("LBL", "lbl_LocTypeDescTitle"), // Location type description
    transaction: common.getLocalizedString("LBL", "lbl_Transaction"), // Transaction
    txType: common.getLocalizedString("LBL", "lbl_TxType"), // Transaction Type
    txPrfx: common.getLocalizedString("LBL", "lbl_TxPrfx"), // Transaction Prefix
    maxNum: common.getLocalizedString("LBL", "lbl_MaxNum"), // Maximum Number
    lastNum: common.getLocalizedString("LBL", "lbl_LastNum"), // Last Number
    year: common.getLocalizedString("LBL", "lbl_Year"), // Year Prefix
    yrPrfx: common.getLocalizedString("LBL", "lbl_YrPrfx"), // Year Prefix
    mthPrfx: common.getLocalizedString("LBL", "lbl_MthPrfx"), // Month Prefix
    alwNeg: common.getLocalizedString("LBL", "lbl_AlwNeg"), // Allow Negetive
    curYr: common.getLocalizedString("LBL", "lbl_CurYr"), // CurYr
    currentYr: common.getLocalizedString("LBL", "CurrentYr"),
    lastYr: common.getLocalizedString("LBL", "LastYr"), // LastYr
    curPer: common.getLocalizedString("LBL", "lbl_CurPer"), // CurPer
    embedChar: common.getLocalizedString("LBL", "lbl_EmbedChar"), // Embed Character
    txDesc: common.getLocalizedString("LBL", "lbl_TxDesc"), // Transaction Description
    acCodeDr: common.getLocalizedString("LBL", "lbl_AcCodeDr"), // AcCodeDr
    acCodeCr: common.getLocalizedString("LBL", "lbl_AcCodeCr"), // AcCodeCr
    costCalSeq: common.getLocalizedString("LBL", "lbl_CostCalSeq"), // Cost calculation sequence
    others: common.getLocalizedString("LBL", "lbl_Others"), // Others
    txRemark: common.getLocalizedString("LBL", "lbl_Remark"), // Remark
    customerCategory: common.getLocalizedString("LBL", "lbl_CustomerCategory"), // Customer Category
    custCateDesc: common.getLocalizedString("LBL", "lbl_CustCateDescTitle"), // Customer Category Description
    pxClsName: common.getLocalizedString("LBL", "lbl_PxClsNameTitle"), // Price Class Name
    businessPartner: common.getLocalizedString("LBL", "lbl_BusinessPartner"), // Business Partner
    miscCharges: common.getLocalizedString("LBL", "lbl_MiscellaneousCharges"), // Miscellaneous Charges
    pxCls: common.getLocalizedString("LBL", "lbl_PxCls"), // Price Class
    payTerm: common.getLocalizedString("LBL", "lbl_PayTerm"), // Pay Term
    termCode: common.getLocalizedString("LBL", "lbl_TermCodeTitle"), // Term Code
    dayCount: common.getLocalizedString("LBL", "lbl_DayCount"), // Day Count
    dayMth: common.getLocalizedString("LBL", "lbl_DayMthTitle"), // Day/Month
    termWeight: common.getLocalizedString("LBL", "lbl_TermWeightTitle"), // Term Weight
    todoList: common.getLocalizedString("LBL", "lbl_todoList"), // To-do-list
    MoldLineDesc: common.getLocalizedString("LBL", "lbl_MoldLineDesc"),
    MoldSupplier: common.getLocalizedString("LBL", "lbl_MoldSupplier"),
    MoldUnitCost: common.getLocalizedString("LBL", "lbl_MoldUnitCost"),
    MoldUnitPx: common.getLocalizedString("LBL", "lbl_MoldUnitPx"),
    unitPx: common.getLocalizedString("LBL", "lbl_MoldUnitPx"), //为了配合后端返回数据 2023-09-23
    AllocatedPx: common.getLocalizedString("LBL", "lbl_AllocatedPx"), //分配价格
    BundlePx: common.getLocalizedString("LBL", "Lbl_BundlePx"), //捆绑价格
    retailTradeDisc: common.getLocalizedString(
      "LBL",
      "lbl_Retail_TradeDiscount"
    ), // Retail Trade Discount
    vendorTradeDisc: common.getLocalizedString(
      "LBL",
      "lbl_Vendor_TradeDiscount"
    ), // Vendor Trade Discount
    print: common.getLocalizedString("LBL", "lbl_Print"), // Print
    prePaid: common.getLocalizedString("LBL", "lbl_PrePaid"), // PrePaid
    termDesc: common.getLocalizedString("LBL", "lbl_TermDescTitle"), // Term Description
    chargeCode: common.getLocalizedString("LBL", "lbl_ChargeCode"), // Charge Code
    chargeDesc: common.getLocalizedString("LBL", "lbl_ChargeDesc"), // Charge Description
    debitAC: common.getLocalizedString("LBL", "lbl_DebitAC"), // Debit Account
    creditAC: common.getLocalizedString("LBL", "lbl_CreditAC"), // Credit Account
    chargeAmt: common.getLocalizedString("LBL", "lbl_ChargeAmt"), // Charge Amount
    pxClsDesc: common.getLocalizedString("LBL", "lbl_PxClsDescTitle"), // Price Class Description
    GP: common.getLocalizedString("LBL", "lbl_GP"), // GP
    UDGP0: common.getLocalizedString("LBL", "lbl_UDGP0Title"), // UDGP0
    UDGP1: common.getLocalizedString("LBL", "lbl_UDGP1Title"), // UDGP1
    UDGP2: common.getLocalizedString("LBL", "lbl_UDGP2Title"), // UDGP2
    UDGP3: common.getLocalizedString("LBL", "lbl_UDGP3Title"), // UDGP3
    UDGP4: common.getLocalizedString("LBL", "lbl_UDGP4Title"), // UDGP4
    createdBy: common.getLocalizedString("LBL", "lbl_CreatedBy"), // Created By
    lastModifiedBy: common.getLocalizedString("LBL", "lbl_LastModifiedBy"), // LastModifiedBy
    desc: common.getLocalizedString("LBL", "lbl_Desc"), // Description
    CustCateDesc: common.getLocalizedString("LBL", "lbl_CustCateDesc"), // 客戶類別説明
    SupCateDesc: common.getLocalizedString("LBL", "lbl_SupCateDesc"), // 供應商類別説明
    TodoDesc: common.getLocalizedString("LBL", "lbl_TodoDesc"), // 代辦事項説明
    altQty: common.getLocalizedString("LBL", "lbl_AltQty"), //  Alt Qty
    loc: common.getLocalizedString("LBL", "lbl_Loc"), // Loc
    altUOM: common.getLocalizedString("LBL", "lbl_AltUOM"), // Alt UOM
    amt: common.getLocalizedString("LBL", "lbl_Amt"), // Amount
    amtRec: common.getLocalizedString("LBL", "lbl_AmtRec"), // Amount Rec
    properties: common.getLocalizedString("LBL", "lbl_Properties"), // Properties
    PO: common.getLocalizedString("LBL", "GR.PO"), // Purchase Order
    otherRef: common.getLocalizedString("LBL", "lbl_OtherRef"), // Other Reference
    stock: common.getLocalizedString("LBL", "lbl_Stock"), // Stock
    price: common.getLocalizedString("LBL", "lbl_Price"), // Price
    ingredients: common.getLocalizedString("LBL", "lbl_Ingredients"), // Ingredients
    UDF: common.getLocalizedString("LBL", "lbl_UDF"), // UDF
    SVECode: common.getLocalizedString("LBL", "lbl_SVECode"), // SVECode
    SVEExpiryDate: common.getLocalizedString("LBL", "lbl_SVEExpiryDate"), // SVEExpiryDate
    shelfLife: common.getLocalizedString("LBL", "lbl_ShelfLife"), // shelfLife
    days: common.getLocalizedString("LBL", "lbl_days"), // days
    dimension: common.getLocalizedString("LBL", "lbl_Dimension"), // Dimension
    abbrevation: common.getLocalizedString("LBL", "lbl_Abbrevation"), // Abbrevation
    hktvItemNum: common.getLocalizedString("LBL", "lbl_HKTVItemNum"), // HKTVItemNum
    hktvMall: common.getLocalizedString("LBL", "lbl_HKTVMall"), // HKTVMall
    shoplineGeneral: common.getLocalizedString("LBL", "lbl_ShopLineGeneral"), // ShopLine General
    shoplineStokke: common.getLocalizedString("LBL", "lbl_ShopLineStokke"), // ShopLine Stokke
    barCode: common.getLocalizedString("LBL", "lbl_BarCode"), // Barcode
    dateLstSls: common.getLocalizedString("LBL", "lbl_DateLstSls"), // Date Last Sale
    catalog: common.getLocalizedString("LBL", "lbl_Catalog"), // Catalog
    cm: common.getLocalizedString("LBL", "lbl_cm"), // cm
    retail: common.getLocalizedString("LBL", "lbl_Retail"), // Retail
    catagory1: common.getLocalizedString("LBL", "lbl_Catagory1"), // Catagory1
    catagory2: common.getLocalizedString("LBL", "lbl_Catagory2"), // Catagory2
    character: common.getLocalizedString("LBL", "lbl_Character"), // Character
    prodLeadTime: common.getLocalizedString("LBL", "lbl_ProductionLeadTime"), // Production Lead Time
    allowZeroCost: common.getLocalizedString("LBL", "lbl_AllowZeroCost"), // Allow Zero Cost
    sellInAltUOMs: common.getLocalizedString("LBL", "lbl_SellInAltUOMs"), // Sell In Alt UOMs
    vendor: common.getLocalizedString("LBL", "GR.Vendor"), // Vendor
    vendorName: common.getLocalizedString("LBL", "Vendor.Name"), // Vendor Name
    FOB: common.getLocalizedString("LBL", "lbl_FOB"), // FOB
    shipMethod: common.getLocalizedString("LBL", "lbl_ShipMethod"), // Shipping Method
    PONum: common.getLocalizedString("LBL", "lbl_PONum"), // PO Number
    supplier: common.getLocalizedString("LBL", "lbl_Supplier"), // Supplier
    factory: common.getLocalizedString("LBL", "lbl_Factory"), // Factory
    UOM: common.getLocalizedString("LBL", "lbl_UOM"), // UOM
    DiscPcnt: common.getLocalizedString("LBL", "lbl_DiscPcnt"), // Discount Percent
    BundleDiscPcnt: common.getLocalizedString("LBL", "lbl_BundleDiscPcnt"), // Bundle Discount Percent
    BundleDiscAmt: common.getLocalizedString("LBL", "lbl_BundleDiscAmt"), //Bundle Disc Amt
    unitCost: common.getLocalizedString("LBL", "lbl_UnitCost"), // Unit Cost
    addBy: common.getLocalizedString("LBL", "lbl_AddBy"), // Add By
    date: common.getLocalizedString("LBL", "lbl_Date"), // Date
    entNum: common.getLocalizedString("LBL", "lbl_EntNum"), // Entity Number
    unitPrice: common.getLocalizedString("LBL", "lbl_UnitPrice"), // Unit Price
    consign: common.getLocalizedString("LBL", "lbl_Consign"), // Consign
    dueDate: common.getLocalizedString("LBL", "lbl_DueDate"), // Due Date
    sign: common.getLocalizedString("LBL", "lbl_sign"), // Signature
    qty: common.getLocalizedString("LBL", "lbl_Qty"), // Qty
    wastage: common.getLocalizedString("LBL", "lbl_Wastage"), // Wastage
    currency: common.getLocalizedString("LBL", "lbl_Cur"), // Currency
    class: common.getLocalizedString("LBL", "lbl_Class"), // Class
    effectiveDate: common.getLocalizedString("LBL", "lbl_EffectiveDate"), // Effective Date
    effectivePeriod: common.getLocalizedString("LBL", "lbl_EffectivePeriod"), // Effective Period
    modifyBy: common.getLocalizedString("LBL", "lbl_ModifyBy"), // Modify By
    modifyDate: common.getLocalizedString("LBL", "lbl_ModifyDate"), // Modify Date
    unitQty: common.getLocalizedString("LBL", "lbl_UnitQty"), // Unit Qty
    unitWeightUOM: common.getLocalizedString("LBL", "lbl_UnitWeightUOM"), // Unit Weight UOM
    unitWeight: common.getLocalizedString("LBL", "lbl_UnitWeight"), // Unit Weight
    pcs: common.getLocalizedString("LBL", "lbl_pcs"), // pcs
    pcsBundle: common.getLocalizedString("LBL", "lbl_PcsBundle"), // Pcs/Bundle
    pcsCtn: common.getLocalizedString("LBL", "lbl_PcsCtn"), // PcsCtn
    pcsInner: common.getLocalizedString("LBL", "lbl_PcsInner"), // PcsInner
    pcsPack: common.getLocalizedString("LBL", "lbl_PcsPack"), // PcsPack
    netWeight: common.getLocalizedString("LBL", "lbl_NetWeight"), // Net Weight
    grossWeight: common.getLocalizedString("LBL", "lbl_GrossWeight"), // Gross Weight
    SOQty: common.getLocalizedString("LBL", "lbl_SOQty"), // SOQty
    POQty: common.getLocalizedString("LBL", "lbl_POQty"), // POQty
    itemSelection: common.getLocalizedString("LBL", "lbl_ItemSelection"), //  Item Selection
    invoiceSelection: common.getLocalizedString("LBL", "lbl_InvoiceSelection"), //  Invoice Selection
    itemNumber: common.getLocalizedString("LBL", "Common.Item"), // Item Number
    itemNum: common.getLocalizedString("LBL", "Common.Item"), // Item Number 为了配合后端返回数据 2023-09-23
    itemDescription: common.getLocalizedString("LBL", "lbl_ItemName"), // Item Description
    general: common.getLocalizedString("LBL", "Common.General"), //General
    delivery: common.getLocalizedString("LBL", "lbl_Delivery"), // Delivery
    deliverydetail: common.getLocalizedString("LBL", "lbl_DeliveryDetail"), // Delivery Detail
    inventoryControl: common.getLocalizedString("LBL", "lbl_InventoryControl"), // Inventory Control
    stockItem: common.getLocalizedString("LBL", "lbl_StockItem"), // Stock Item
    itemLine: common.getLocalizedString("LBL", "lbl_ItemLine"), // Item Line
    itemMaster: common.getLocalizedString("LBL", "lbl_ItemMaster"), // Item Master
    itemNo: common.getLocalizedString("LBL", "lbl_ItemNo"), // Item No.
    item: common.getLocalizedString("LBL", "lbl_Item"), //Item
    bundle: common.getLocalizedString("LBL", "lbl_Bundle"), //Bundle
    status: common.getLocalizedString("LBL", "lbl_Status"), // Status
    seq: common.getLocalizedString("LBL", "lbl_Seq"), // Seq
    charDesc: common.getLocalizedString("LBL", "lbl_CharDesc"), // Character Description
    charCode: common.getLocalizedString("LBL", "lbl_CharCode"), // Character Code
    curCodeDesc: common.getLocalizedString("LBL", "lbl_CurCodeDesc"), // Currency code description
    invoice: common.getLocalizedString("LBL", "lbl_Invoice"), //Invoice
    sales: common.getLocalizedString("LBL", "lbl_Sales"), //Sales
    invoicePrinting: common.getLocalizedString("LBL", "lbl_InvoicePrinting"), // Invoice Printing
    invoiceReprint: common.getLocalizedString("LBL", "lbl_InvoiceReprint"), // Invoice Printing
    invoicePost: common.getLocalizedString("LBL", "lbl_InvoicePost"), // Invoice Post
    invoiceUnPost: common.getLocalizedString("LBL", "lbl_InvoiceUnPost"), // Invoice UnPost
    goodsReceivePost: common.getLocalizedString("LBL", "lbl_GoodsReceivePost"), // Goods Receive Post
    goodsReceiveUnPost: common.getLocalizedString(
      "LBL",
      "lbl_GoodsReceiveUnPost"
    ), // Goods Receive UnPost
    postToXero: common.getLocalizedString("LBL", "lbl_PostToXero"),
    pickLst: common.getLocalizedString("LBL", "lbl_PickLst"),
    pickingListPrinting: common.getLocalizedString(
      "LBL",
      "lbl_PickingListPrinting"
    ), //PickingList Printing
    setup: common.getLocalizedString("LBL", "lbl_Setup"), // Setup
    seriesCode: common.getLocalizedString("LBL", "lbl_SeriesCodeTitle"), //Series Code
    seriesDesc: common.getLocalizedString("LBL", "lbl_SeriesDescTitle"), //Series Desc
    txNum: common.getLocalizedString("LBL", "lbl_TxNum"), // Transaction Num
    txStatus: common.getLocalizedString("LBL", "lbl_TxStatus"), //Transaction Status
    aprvStatus: common.getLocalizedString("LBL", "lbl_AprvStatus"), //Aprv Status
    list: common.getLocalizedString("LBL", "lbl_List"), //List
    calendar: common.getLocalizedString("LBL", "lbl_Calendar"), //lbl_calendars
    userId: common.getLocalizedString("LBL", "lbl_UserId"), //User Id
    userName: common.getLocalizedString("LBL", "lbl_UserName"), //User name
    email: common.getLocalizedString("LBL", "lbl_emailId"), //Email Id
    eventCode: common.getLocalizedString("LBL", "lbl_eventCode"), //Event Code
    entityLocation: common.getLocalizedString("LBL", "lbl_entityLocation"), //Entity Location
    address: common.getLocalizedString("LBL", "lbl_address"), //Address
    salesOrder: common.getLocalizedString("LBL", "lbl_SalesOrder"), //Sales order
    closeSalesOrder: common.getLocalizedString("LBL", "lbl_closeSalesOrder"), //Close Sales order
    invoiceNo: common.getLocalizedString("LBL", "lbl_InvoiceNo"), //Invoice No.
    itemDetail: common.getLocalizedString("LBL", "lbl_ItemDetail"), //Item Detail
    miscChg: common.getLocalizedString("LBL", "lbl_MiscChg"), //Misc. Chg.
    deliveryAdrs: common.getLocalizedString("LBL", "lbl_DeliveryAdrs"), // Delivery Loc.
    billLoc: common.getLocalizedString("LBL", "lbl_EntBillLoc"), // Billing Loc.
    shippingMark: common.getLocalizedString("LBL", "lbl_shippingMark"), // ShippingMark .
    sideMark: common.getLocalizedString("LBL", "lbl_sideShippingMark"), // sideShippingMark .
    slsMan: common.getLocalizedString("LBL", "lbl_SlsMan"), // Salesman
    outLoc: common.getLocalizedString("LBL", "lbl_OutLoc"), // Out Loc.
    inLoc: common.getLocalizedString("LBL", "lbl_InLoc"), // In Loc.
    othrRefNo: common.getLocalizedString("LBL", "lbl_OthrRefNo"), // Other Reference no.
    refNo: common.getLocalizedString("LBL", "lbl_RefNo"), // Reference No.
    refNum: common.getLocalizedString("LBL", "lbl_RefNo"), // Reference No.为了配合后端返回数据 2023-09-23
    entLoc: common.getLocalizedString("LBL", "lbl_EntLoc"), // Entity Location
    trialOrder: common.getLocalizedString("LBL", "lbl_IsTrialOrder"), // Is Trial Order
    pickingListRemark: common.getLocalizedString(
      "LBL",
      "lbl_PickingListRemark"
    ), // Picking List Remark
    invoiceDate: common.getLocalizedString("LBL", "lbl_InvoiceDate"), // Invoice Date
    paymentTerm: common.getLocalizedString("LBL", "lbl_PaymentTerms"), // Payment Terms
    warehouse: common.getLocalizedString("LBL", "lbl_Warehouse"), // WH Loc.
    cartNo: common.getLocalizedString("LBL", "lbl_CartNo"), // Carton Qty
    invoiceRemark: common.getLocalizedString("LBL", "lbl_InvoiceRemark"), // Invoice Remark
    pcsPack: common.getLocalizedString("LBL", "lbl_PcsPack"), // Pcs/Pack
    stockBalance: common.getLocalizedString("LBL", "lbl_StockBalance"), // Stock Balance
    orglineDsc: common.getLocalizedString("LBL", "lbl_OrgLineDsc"), //Original Line Dis%
    lineDsc: common.getLocalizedString("LBL", "lbl_LineDsc"), // Line Dis%
    lineDisc: common.getLocalizedString("LBL", "lbl_LineDsc"), // Line Dis% 为了配合后端返回数据 2023-09-23
    dscamt: common.getLocalizedString("LBL", "lbl_DscAmount"), // Line Dis%
    mmrules: common.getLocalizedString("LBL", "lbl_MMRules"), // MMRules
    cancelSORemaider: common.getLocalizedString("LBL", "lbl_CancelSORemaider"), // Cancel OS/SO
    sOTxNum: common.getLocalizedString("LBL", "lbl_SOTxNum"), // SO No.
    ctnFr: common.getLocalizedString("LBL", "lbl_CtnFr"), // Ctn Fr
    ctnTo: common.getLocalizedString("LBL", "CtnTo"), // Ctn To
    CBFCtn: common.getLocalizedString("LBL", "lbl_CBFCtn"), // CBFCtn
    CBFSubtotal: common.getLocalizedString("LBL", "lbl_CBFSubTotal"), // CBF Subtotal
    discount: common.getLocalizedString("LBL", "lbl_Discount"), // Discount
    totQty: common.getLocalizedString("LBL", "lbl_TotQty"), // Total Qty
    totalAmt: common.getLocalizedString("LBL", "lbl_TotalAmt"), // Total Amount
    attachment: common.getLocalizedString("LBL", "lbl_Attachment"), // Attachment
    deliveryDate: common.getLocalizedString("LBL", "lbl_DeliveryDate"), // Delivery Date
    deliveryTime: common.getLocalizedString("LBL", "lbl_DeliveryTime"), // Delivery Time
    zeekHDNo: common.getLocalizedString("LBL", "lbl_zeekHDNo"), //ZeekHDNo
    contact: common.getLocalizedString("LBL", "lbl_Contact"), // Contact
    contactNum: common.getLocalizedString("LBL", "lbl_ContactNum"), // Contact Number
    fileName: common.getLocalizedString("LBL", "lbl_FileName"), // File Name
    fileSize: common.getLocalizedString("LBL", "lbl_FileSize"), // Size
    fileTime: common.getLocalizedString("LBL", "lbl_FileTime"), // File Time
    sizeAdj: common.getLocalizedString("LBL", "lbl_SizeAdj"), //Size Adjust
    UOMDesc: common.getLocalizedString("LBL", "lbl_UOMDesc"), // UOM description
    soBalance: common.getLocalizedString("LBL", "lbl_SOBal"), // SO balance
    printCount: common.getLocalizedString("LBL", "lbl_PrintCount"), // Print Count
    custLoc: common.getLocalizedString("LBL", "lbl_CustLoc"), // Customer Loc.
    apprStatus: common.getLocalizedString("LBL", "lbl_ApprStatus"), // Approval Status
    shop: common.getLocalizedString("LBL", "lbl_Shop"), // Shop
    entName: common.getLocalizedString("LBL", "lbl_EntName"), // Entity name
    txDate: common.getLocalizedString("LBL", "lbl_TxDate"), // Tx Date
    settlementdate: common.getLocalizedString("LBL", "lbl_SettlementDate"), // Settlement Date
    totunsettleamt: common.getLocalizedString("LBL", "lbl_totUnsettleAmt"), // Total Unsettled Amount
    totamt: common.getLocalizedString("LBL", "lbl_totAmt"), // Total Unsettled Amount
    changeInvoiceDate: common.getLocalizedString(
      "LBL",
      "lbl_ChangeInvoiceDate"
    ), // Change Invoice Date to
    hideFilter: common.getLocalizedString("LBL", "lbl_HideFilter"), // Hide filter
    showFilter: common.getLocalizedString("LBL", "lbl_ShowFilter"), // Show filter
    customer: common.getLocalizedString("LBL", "Inv.Customer"), //  Customer
    to: common.getLocalizedString("LBL", "lbl_TO"), // to
    fromTxNum: common.getLocalizedString("LBL", "lbl_FromTxNum"), // from Tx Num
    txWithin: common.getLocalizedString("LBL", "lbl_TxWithin"), // TxWithin
    name: common.getLocalizedString("LBL", "lbl_Name"), // Name
    approval: common.getLocalizedString("LBL", "lbl_Approval"), // Approval
    txQty: common.getLocalizedString("LBL", "lbl_TxQty"), // Transaction qty
    deliveryLbL: common.getLocalizedString("LBL", "lbl_Delivery_label"), // Delivery
    soNum: common.getLocalizedString("LBL", "lbl_SONum"), // SO No.
    sONum: common.getLocalizedString("LBL", "lbl_SoNum"), // SO No. 为了配合后端返回数据 2023-09-23
    soDate: common.getLocalizedString("LBL", "lbl_SODate"), // SO Date
    itemStatus: common.getLocalizedString("LBL", "lbl_ItemStatus"), // Item status
    defaultPrice: common.getLocalizedString("LBL", "lbl_DefaultPrice"), // Default Price
    priceLocked: common.getLocalizedString("LBL", "lbl_PriceLocked"), // Price Locked
    invQty: common.getLocalizedString("LBL", "lbl_InvQty"), // Invoice Qty
    cancelledQty: common.getLocalizedString("LBL", "lbl_CancelledQty"), // Cancelled Qty
    goodsReceive: common.getLocalizedString("LBL", "lbl_GoodsReceive"), // Goods receive
    stockTransfer: common.getLocalizedString("LBL", "lbl_StockTransfer"), // Stock transfer
    qtyAdjustment: common.getLocalizedString("LBL", "lbl_QtyAdjustment"), // Qty adjustment
    costAdjustment: common.getLocalizedString("LBL", "lbl_CostAdjustment"), // Cost adjustment
    purchaseReturn: common.getLocalizedString("LBL", "lbl_PurchaseReturn"), // Purchase return
    stockTake: common.getLocalizedString("LBL", "lbl_StockTake"), // Stock take
    enquiry: common.getLocalizedString("LBL", "lbl_Enquiry"), // Enquiry
    enquire: common.getLocalizedString("LBL", "lbl_Enquire"), // Enquiry
    goodsReceiveNo: common.getLocalizedString("LBL", "lbl_GoodsReceiveNo"), // Goods receive no.
    lineRemark: common.getLocalizedString("LBL", "lbl_LineRemark"), // Line remark
    lineRem: common.getLocalizedString("LBL", "lbl_LineRemark"), // Line remark 为了配合后端返回数据 2023-09-23
    vendorNo: common.getLocalizedString("LBL", "lbl_VendorNo"), // Vendor No
    vendorInvNo: common.getLocalizedString("LBL", "lbl_VendorInvNo"), // Vendor Inv No
    GRDate: common.getLocalizedString("LBL", "lbl_GRDate"), // GR Date
    stockTransferNo: common.getLocalizedString("LBL", "lbl_StockTransferNo"), // Stock transfer no
    fromLocation: common.getLocalizedString("LBL", "lbl_FromLocation"), // From location
    toLocation: common.getLocalizedString("LBL", "lbl_ToLocation"), // To location
    transferDate: common.getLocalizedString("LBL", "lbl_TransferDate"), // Transfer date
    resetStockBalance: common.getLocalizedString(
      "LBL",
      "lbl_ResetStockBalance"
    ), // Reset stock balance
    positiveStockBalance: common.getLocalizedString(
      "LBL",
      "lbl_PositiveStockBalance"
    ), // Positive stock balance
    negativeStockBalance: common.getLocalizedString(
      "LBL",
      "lbl_NegativeStockBalance"
    ), // Negative stock balance
    includePending: common.getLocalizedString("LBL", "lbl_IncludePending"), // Include pending
    generate: common.getLocalizedString("LBL", "lbl_Generate"), // Generate
    totCBF: common.getLocalizedString("LBL", "lbl_TotCBF"), // Total CBF
    businessEntity: common.getLocalizedString("LBL", "lbl_BusinessEntity"), //Business Entity
    EntityLocation: common.getLocalizedString("LBL", "lbl_EntityLocation"), //Entity Location

    entityCode: common.getLocalizedString("LBL", "lbl_EntityCode"), //Entity code
    autoId: common.getLocalizedString("LBL", "lbl_AutoId"), //Auto ID
    closeAcc: common.getLocalizedString("LBL", "lbl_CloseAcc"), //Close Acc.
    accClosed: common.getLocalizedString("LBL", "lbl_AccClosed"), //A/C Closed
    type: common.getLocalizedString("LBL", "lbl_Type"), // Type
    size: common.getLocalizedString("LBL", "lbl_Size"), // Size
    launguage: common.getLocalizedString("LBL", "lbl_Launguage"), // launguage
    dateExpire: common.getLocalizedString("LBL", "lbl_DateExpire"), // Date Expire
    brNum: common.getLocalizedString("LBL", "lbl_BRNum"), // B.R. Number
    contacts: common.getLocalizedString("LBL", "lbl_Contacts"), // Contacts
    contactsNum: common.getLocalizedString("LBL", "lbl_ContactsNum"), // Contacts Number
    customerGroup: common.getLocalizedString("LBL", "lbl_CustomerGroup"), // customer Group
    accessExtranet: common.getLocalizedString("LBL", "lbl_AccessExtranet"), // Access Extranet
    shopDescription: common.getLocalizedString("LBL", "lbl_ShopDescription"), // Shop Description
    extranetPass: common.getLocalizedString("LBL", "lbl_ExtranetPass"), // Extranet Password
    districtDescription: common.getLocalizedString(
      "LBL",
      "lbl_DistrictDescription"
    ), // District Description
    DefWHLoc: common.getLocalizedString("LBL", "lbl_DefWHLoc"), // DefWHLoc
    DefInvPrfx: common.getLocalizedString("LBL", "lbl_DefInvPrfx"), // DefInvPrfx

    room: common.getLocalizedString("LBL", "lbl_Room"), // Room
    routeID: common.getLocalizedString("LBL", "lbl_RouteID"), // Room
    flat: common.getLocalizedString("LBL", "lbl_Flat"), // Flat
    floor: common.getLocalizedString("LBL", "lbl_Floor"), // Floor
    block: common.getLocalizedString("LBL", "lbl_Block"), // Block
    building: common.getLocalizedString("LBL", "lbl_Building"), // Building
    estate: common.getLocalizedString("LBL", "lbl_Estate"), // Estate
    court: common.getLocalizedString("LBL", "lbl_Court"), // Court
    streetName: common.getLocalizedString("LBL", "lbl_StreetName"), // Street Name
    upload: common.getLocalizedString("LBL", "lbl_Upload"), // upload
    unload: common.getLocalizedString("LBL", "lbl_Unload"), // unload
    creditLimitAmt: common.getLocalizedString("LBL", "lbl_CreditLimitAmt"), // Credit Limit Amt
    tradeDisOff: common.getLocalizedString("LBL", "lbl_TradeDisOff"), // Trade Dis. (%Off)
    goodsAllocationSeque: common.getLocalizedString(
      "LBL",
      "lbl_GoodsAllocationSeque"
    ), // Goods Allocation Seque
    officeAddCode: common.getLocalizedString("LBL", "lbl_OfficeAddCode"), // Office Address Code
    deliveryAddCode: common.getLocalizedString("LBL", "lbl_DeliveryAddCode"), // Delivery Address Code
    deliveryAddress: common.getLocalizedString("LBL", "lbl_DeliveryAddress"), // Delivery Address
    ref1: common.getLocalizedString("LBL", "lbl_Ref1"), // ref1
    ref2: common.getLocalizedString("LBL", "lbl_Ref2"), // ref2
    ref3: common.getLocalizedString("LBL", "lbl_Ref3"), // ref3
    holdAcc: common.getLocalizedString("LBL", "lbl_HoldAccount"), // Hold Account
    blackList: common.getLocalizedString("LBL", "lbl_BlackList"), // Black List
    useEDI: common.getLocalizedString("LBL", "lbl_UseEDI"), // Use EDI
    accNo: common.getLocalizedString("LBL", "lbl_AccNo"), //Account No
    balance: common.getLocalizedString("LBL", "lbl_Balance"), //Balance
    fusionInterface: common.getLocalizedString("LBL", "lbl_FusionInterface"), //Fusion Interface
    buyerId: common.getLocalizedString("LBL", "lbl_BuyerId"), //Buyer Id
    poSelection: common.getLocalizedString("LBL", "lbl_POSelection"), //  Purchase order selection
    reportSelection: common.getLocalizedString("LBL", "lbl_ReportSelection"), // Report Selection
    currencySelection: common.getLocalizedString(
      "LBL",
      "lbl_CurrencySelection"
    ), //  Currency Selection
    paymentTermSelection: common.getLocalizedString(
      "LBL",
      "lbl_PaymentTermSelection"
    ), //  Payment Term Selection
    whLocSelection: common.getLocalizedString("LBL", "lbl_WhLocSelection"), //  Wh Loc Selection
    vendorSelection: common.getLocalizedString("LBL", "lbl_VendorSelection"), //  Vendor Selection
    factorySelection: common.getLocalizedString("LBL", "lbl_FactorySelection"), //  Factory Selection
    barcodeSelection: common.getLocalizedString("LBL", "lbl_BarcodeSelection"), //  Barcode Selection
    dateExpSelection: common.getLocalizedString("LBL", "lbl_DateExpSelection"), // Expiry Date Selection
    uomSelection: common.getLocalizedString("LBL", "lbl_UOMSelection"), //  UOM Selection
    soPxHistSelection: common.getLocalizedString(
      "LBL",
      "lbl_sopxhistSelection"
    ), //SO Px Hist Selection
    grSelection: common.getLocalizedString("LBL", "lbl_GRSelection"), //  GR Selection
    entityNumberSelection: common.getLocalizedString(
      "LBL",
      "lbl_EntityNumSelection"
    ), //  Entity number selection
    miscChargeSelection: common.getLocalizedString(
      "LBL",
      "lbl_MiscChargeSelection"
    ), // Miscellaneous Charge Selection
    remarkSelection: common.getLocalizedString("LBL", "lbl_RemarkSelection"), //  Remark Selection
    stkTfRecordSelection: common.getLocalizedString(
      "LBL",
      "lbl_StkTfRecordSelection"
    ), //  Stock transfer record Selection
    soSelection: common.getLocalizedString("LBL", "lbl_SOSelection"), //  SO selection
    locationSelection: common.getLocalizedString(
      "LBL",
      "lbl_LocationSelection"
    ), //  Location Selection
    pickingListRemarkSelection: common.getLocalizedString(
      "LBL",
      "lbl_PickingListRemarkSelection"
    ), //  PickingList Remark Selection
    invoiceRemarkSelection: common.getLocalizedString(
      "LBL",
      "lbl_InvoiceRemarkSelection"
    ), //  Invoice Remark Selection
    eventCodeSelection: common.getLocalizedString(
      "LBL",
      "lbl_EventCodeSelection"
    ), //  Event Code Selection
    salesmanSelection: common.getLocalizedString(
      "LBL",
      "lbl_SalesmanSelection"
    ), //  Salesman Selection
    billingAddressSelection: common.getLocalizedString(
      "LBL",
      "lbl_SelectLocation"
    ), //  Billing Address Selection
    deliveryAddressSelection: common.getLocalizedString(
      "LBL",
      "lbl_SelectLocation"
    ), //  Delivery Address Selection
    copySOSelection: common.getLocalizedString("LBL", "lbl_CopySOSelection"), //  Sales Order Selection
    invoiceSelection: common.getLocalizedString("LBL", "lbl_InvoiceSelection"), //  Invoice Selection
    itemByDescSelection: common.getLocalizedString(
      "LBL",
      "lbl_ItemByDescSelectionSelection"
    ), //  Item By Description Selection
    category1Selection: common.getLocalizedString(
      "LBL",
      "lbl_Category1Selection"
    ), //  Category1 Selection
    category2Selection: common.getLocalizedString(
      "LBL",
      "lbl_Category2Selection"
    ), //  Category2 Selection
    brandSelection: common.getLocalizedString("LBL", "lbl_BrandSelection"), //  Brand Selection
    binSelection: common.getLocalizedString("LBL", "lbl_BinSelection"), //  Bin Selection
    characterSelection: common.getLocalizedString(
      "LBL",
      "lbl_CharacterSelection"
    ), //  Character Selection
    priceClassSelection: common.getLocalizedString(
      "LBL",
      "lbl_PriceClassSelection"
    ), //  Price Class Selection
    pending: common.getLocalizedString("LBL", "lbl_Pending"), //Pending
    cancelled: common.getLocalizedString("LBL", "lbl_Cancelled"), //Cancelled
    posted: common.getLocalizedString("LBL", "lbl_Posted"), //Posted
    printed: common.getLocalizedString("LBL", "lbl_Printed"), //Printed
    open: common.getLocalizedString("LBL", "lbl_Open"), //Open
    invoiced: common.getLocalizedString("LBL", "lbl_Invoiced"), //Invoiced
    closed: common.getLocalizedString("LBL", "lbl_Closed"), //Closed
    unsettled: common.getLocalizedString("LBL", "lbl_Unsettled"), //Unsettled
    settled: common.getLocalizedString("LBL", "lbl_Settled"), //Settled
    show: common.getLocalizedString("LBL", "lbl_Show"), //Show
    approvalreq: common.getLocalizedString("LBL", "lbl_ApprovalReq"), //Approval Req.
    approvalnotreq: common.getLocalizedString("LBL", "lbl_ApprovalNotReq"), //Approval Not Req.
    approved: common.getLocalizedString("LBL", "lbl_Approved"), //Approved
    approveBy: common.getLocalizedString("LBL", "lbl_ApproveBy"), //Approve By
    copyFromQuotation: common.getLocalizedString(
      "LBL",
      "lbl_copyFromQuotation"
    ), //copyFromQuotation
    rejected: common.getLocalizedString("LBL", "lbl_Rejected"), //Rejected
    qtyadjustment: common.getLocalizedString("LBL", "lbl_StockQtyAdjustment"), // Stock Quantity Adjustment
    prefix: common.getLocalizedString("LBL", "lbl_Prefix"), // Prefix
    referenceNumber: common.getLocalizedString("LBL", "lbl_ReferenceNumber"), // Reference No.
    whLoc: common.getLocalizedString("LBL", "lbl_WHLoc"), // WH Loc
    projectCode: common.getLocalizedString("LBL", "lbl_ProjectCode"), // Project Code
    onHandQty: common.getLocalizedString("LBL", "lbl_ONHandQty"), // On Hand Qty
    uom: common.getLocalizedString("LBL", "lbl_UOM"), // UOM
    transactionTypeSelection: common.getLocalizedString(
      "LBL",
      "lbl_TransactionTypeSelection"
    ), //  Transaction Type Selection
    category1: common.getLocalizedString("LBL", "lbl_Category1"), //  Catagory1
    category2: common.getLocalizedString("LBL", "lbl_Category2"), //  Catagory2
    POScheduleEnquiry: common.getLocalizedString(
      "LBL",
      "lbl_POScheduleEnquiry"
    ), //  PO Schedule Enquiry
    poOrderApproal: common.getLocalizedString("LBL", "lbl_PoOrderApproal"), // Purchase order approval
    invoiceApproval: common.getLocalizedString("LBL", "lbl_InvoiceApproval"), // Invoice Approval
    invoiceStatus: common.getLocalizedString("LBL", "lbl_InvoiceStatus"), // Invoice Status
    changeInvoiceStatus: common.getLocalizedString(
      "LBL",
      "lbl_ChangeInvoiceStatus"
    ), //Change Invoice Status
    invoiceSettlement: common.getLocalizedString(
      "LBL",
      "lbl_InvoiceSettlement"
    ), // Invoice Settlement
    invoiceSummary: common.getLocalizedString("LBL", "lbl_InvoiceSummary"), // Invoice Summary
    goodsPickingVerification: common.getLocalizedString(
      "LBL",
      "lbl_ GoodsPickingVerification"
    ), // Goods picking verification
    stkBalDate: common.getLocalizedString("LBL", "lbl_StkBalDate"), // Stock Balance Date
    qtyAdjustmentRecordSelection: common.getLocalizedString(
      "LBL",
      "lbl_QtyAdjustmentRecordSelection"
    ), // Stock Quantity Adjustment Selection
    stockBalanceEnquiry: common.getLocalizedString(
      "LBL",
      "lbl_StockBalanceEnquiry"
    ), // Stock Balance Enquiry
    last: common.getLocalizedString("LBL", "lbl_Last"), // Last
    lastSales: common.getLocalizedString("LBL", "lbl_LastSales"), // Last Sales
    mrCost: common.getLocalizedString("LBL", "lbl_MRCost"), // MR Cost
    hideSearchFilter: common.getLocalizedString("LBL", "lbl_HideSearchFilter"), // Hide Search Filter
    showSearchFilter: common.getLocalizedString("LBL", "lbl_ShowSearchFilter"), // Show Search Filter
    from: common.getLocalizedString("LBL", "lbl_FROM"), //From
    lastRecordDate: common.getLocalizedString("LBL", "lbl_LastRecordDate"), //Last Rec'd Date
    checkLastReceiptDate: common.getLocalizedString(
      "LBL",
      "lbl_CheckLastReceiptDate"
    ), // Check Last Receipt Date
    stockDate: common.getLocalizedString("LBL", "lbl_StockDate"), // Stock Date
    includeDeletedItem: common.getLocalizedString(
      "LBL",
      "lbl_IncludeDeletedItem"
    ), //Include Deleted Item
    inActiveFor: common.getLocalizedString("LBL", "lbl_InActiveFor"), // Inactive For
    showQty: common.getLocalizedString("LBL", "lbl_ShowQty"), // Show Qty
    showCost: common.getLocalizedString("LBL", "lbl_ShowCost"), // Show Cost
    YTDSales: common.getLocalizedString("LBL", "lbl_YTDSales"), // YTD Sales
    showInAltUnit: common.getLocalizedString("LBL", "lbl_ShowInAltUnit"), // Show In Alt Unit
    company: common.getLocalizedString("LBL", "lbl_Company"), // Company
    stockCostAdjustment: common.getLocalizedString(
      "LBL",
      "lbl_StockCostAdjustment"
    ), // Stock Cost Adjustment
    returnType: common.getLocalizedString("LBL", "lbl_ReturnType"), // Return Type
    returnDate: common.getLocalizedString("LBL", "lbl_ReturnDate"), // Return Date
    rate: common.getLocalizedString("LBL", "lbl_Rate"), // Rate
    warehouseAddress: common.getLocalizedString("LBL", "lbl_WarehouseAddress"), // Warehouse Address
    hedgingNum: common.getLocalizedString("LBL", "lbl_HedgingNum"), // Hedging Number
    returnTransaction: common.getLocalizedString(
      "LBL",
      "lbl_ReturnTransaction"
    ), // Return Transaction
    order: common.getLocalizedString("LBL", "lbl_Order"), // Order
    netPrice: common.getLocalizedString("LBL", "lbl_NetPrice"), // Net Price
    clientNo: common.getLocalizedString("LBL", "lbl_ClientNo"), // Client No.
    salesperson: common.getLocalizedString("LBL", "lbl_Salesperson"), // Salesperson
    transactionCycle: common.getLocalizedString("LBL", "lbl_TransactionCycle"), // Transaction Cycle
    credit: common.getLocalizedString("LBL", "lbl_Credit"), // Credit
    check: common.getLocalizedString("LBL", "lbl_check"), // Check

    promissoryInformation: common.getLocalizedString(
      "LBL",
      "lbl_PromissoryInformation"
    ), // Promissory Information
    chequeNo: common.getLocalizedString("LBL", "lbl_ChequeNo"), // Cheque No.
    transactionNo: common.getLocalizedString("LBL", "lbl_TransactionNo"), // Transaction No.
    selectedTotal: common.getLocalizedString("LBL", "lbl_SelectedTotal"), // Selected total
    records: common.getLocalizedString("LBL", "lbl_Records"), // records

    StockLedger: common.getLocalizedString("LBL", "lbl_StockLedger"), // StockLedger
    showinaltunit: common.getLocalizedString("LBL", "lbl_showinaltunit"), // Show In Atl Unit

    in: common.getLocalizedString("LBL", "lbl_in"), // In
    out: common.getLocalizedString("LBL", "lbl_out"), // Out
    allloc: common.getLocalizedString("LBL", "lbl_allloc"), // All Loc
    POanalysis: common.getLocalizedString("LBL", "lbl_POanalysis"), // PO Analysis
    salesanalysis: common.getLocalizedString("LBL", "lbl_SalesAnalysis"), // Sales Analysis
    stockanalysis: common.getLocalizedString("LBL", "lbl_stockanalysis"), // Stock Analysis
    MobilePhone: common.getLocalizedString("LBL", "lbl_MobilePhone"), // Mobile Phone
    pager: common.getLocalizedString("LBL", "lbl_pager"), // Pager
    edisenderID: common.getLocalizedString("LBL", "lbl_edisenderID"), // EDI Sender ID
    vendorCategory: common.getLocalizedString("LBL", "lbl_vendorCategory"), // Vendor Category
    vendorCateDesc: common.getLocalizedString("LBL", "lbl_vendorCateDesc"), // Vendor Category Description
    pleaseselect: common.getLocalizedString("LBL", "lbl_pleaseselect"), // Please Select

    DocumentLibrary: common.getLocalizedString("LBL", "lbl_DocumentLibrary"), // Document Library
    DocReceived: common.getLocalizedString("LBL", "lbl_DocReceived"), // Document Received
    countrySelection: common.getLocalizedString("LBL", "lbl_countrySelection"), //  Country Selection

    //2020-09-22
    Administration: common.getLocalizedString("LBL", "lbl_Administration"), //  Administration
    UserGrpMaintenance: common.getLocalizedString(
      "LBL",
      "lbl_UserGrpMaintenance"
    ), //  User Group Maintenance
    usermaintenance: common.getLocalizedString("LBL", "lbl_usermaintenance"), //  User Maintenance
    functionsecurity: common.getLocalizedString("LBL", "lbl_functionsecurity"), //  Function Security
    usergroup: common.getLocalizedString("LBL", "lbl_usergroup"), //  User Group
    defaultpath: common.getLocalizedString("LBL", "lbl_defaultpath"), //  Default Path
    supervisor: common.getLocalizedString("LBL", "lbl_Supervisor"), //  Supervisor
    WinADName: common.getLocalizedString("LBL", "lbl_WinADName"), //  WinADName
    shopuser: common.getLocalizedString("LBL", "lbl_shopuser"), //  Shop User
    cost: common.getLocalizedString("LBL", "lbl_cost"), //  cost
    groupid: common.getLocalizedString("LBL", "lbl_groupid"), //  Group Id
    groupdescription: common.getLocalizedString("LBL", "lbl_groupdescription"), //  Group Description
    userGrpSelection: common.getLocalizedString("LBL", "lbl_userGrpSelection"), //  User Group Selection

    SystemAdministration: common.getLocalizedString(
      "LBL",
      "lbl_SystemAdministration"
    ), //  System Administration
    MasterMaintenance: common.getLocalizedString(
      "LBL",
      "lbl_MasterMaintenance"
    ), //  Master Maintenance
    Importer: common.getLocalizedString("LBL", "lbl_Importer"), //  Importer
    PurchaseOrder: common.getLocalizedString("LBL", "lbl_PurchaseOrder"), //  Purchase Order
    Quotation: common.getLocalizedString("LBL", "lbl_Quotation"), //  Quotation
    Sales: common.getLocalizedString("LBL", "lbl_Sales"), //  Sales
    InventoryControl: common.getLocalizedString("LBL", "lbl_InventoryControl"), //  Inventory Control
    NightJob: common.getLocalizedString("LBL", "lbl_NightJob"), //  Night Job
    MonthEnd: common.getLocalizedString("LBL", "lbl_MonthEnd"), // Month End
    Reports: common.getLocalizedString("LBL", "lbl_Reports"), //  Reports
    Directory: common.getLocalizedString("LBL", "lbl_Directory"), //  Directory

    MenuID: common.getLocalizedString("LBL", "lbl_MenuID"), //  MenuID
    AlwWrite: common.getLocalizedString("LBL", "lbl_AlwWrite"), //  Write
    AlwRead: common.getLocalizedString("LBL", "lbl_AlwRead"), //  Read
    AlwPrt: common.getLocalizedString("LBL", "lbl_AlwPrt"), //  Print
    AlwImp: common.getLocalizedString("LBL", "lbl_AlwImp"), //  Import

    ChangePassword: common.getLocalizedString("LBL", "lbl_ChangePassword"), //  Change Password
    OldPassword: common.getLocalizedString("LBL", "lbl_OldPassword"), //  Old Password
    NewPassword: common.getLocalizedString("LBL", "lbl_NewPassword"), //   New Password
    ConfirmPassword: common.getLocalizedString("LBL", "lbl_ConfirmPassword"), //  Confirm Password
    userList: common.getLocalizedString("LBL", "lbl_userList"), //  User List
    user: common.getLocalizedString("LBL", "lbl_user"), //  User
    view: common.getLocalizedString("LBL", "lbl_view"), //  view
    resigned: common.getLocalizedString("LBL", "lbl_resigned"), //  resigned
    Password: common.getLocalizedString("LBL", "lbl_Password"), //  Password
    dateresigned: common.getLocalizedString("LBL", "lbl_dateresigned"), //  Date Resigned

    //2020-10-16
    ExchangeRate: common.getLocalizedString("LBL", "lbl_ExchangeRate"), //  Exchange Rate
    currencyCode: common.getLocalizedString("LBL", "lbl_currencyCode"), //  Currency Code
    currencyDesc: common.getLocalizedString("LBL", "lbl_currencyDesc"), //  Currency Desc
    reciprocal: common.getLocalizedString("LBL", "lbl_Reciprocal"), //  Reciprocal
    baseUnit: common.getLocalizedString("LBL", "lbl_BaseUnit"), //  BaseUnit

    financialperiod: common.getLocalizedString("LBL", "lbl_financialperiod"), //  Financial Period
    fiscalPer: common.getLocalizedString("LBL", "lbl_fiscalPer"), //  Fiscal Period
    startDate: common.getLocalizedString("LBL", "lbl_startDate"), //  Start Date
    endDate: common.getLocalizedString("LBL", "lbl_endDate"), //  End Date
    periodClosed: common.getLocalizedString("LBL", "lbl_periodClosed"), //  Period Closed
    txMoved: common.getLocalizedString("LBL", "lbl_txMoved"), //  Tx Moved
    period: common.getLocalizedString("LBL", "lbl_period"), //  period

    taskNum: common.getLocalizedString("LBL", "lbl_taskNum"), //  Task number
    dateoper: common.getLocalizedString("LBL", "lbl_dateoper"), //  Date Operation
    operator: common.getLocalizedString("LBL", "lbl_operator"), //  Operator
    operation: common.getLocalizedString("LBL", "lbl_operation"), //  Operation

    //2020-11-24
    systemParamUser: common.getLocalizedString("LBL", "lbl_systemParamUser"), //  System Parameter (User Maintenance)
    SystemPath: common.getLocalizedString("LBL", "lbl_SystemPath"), //  System Path
    compEngName: common.getLocalizedString("LBL", "lbl_compEngName"), //  Company English Name
    compChiName: common.getLocalizedString("LBL", "lbl_compChiName"), //  Company Chinese Name
    announceOnInvoice: common.getLocalizedString(
      "LBL",
      "lbl_announceOnInvoice"
    ), //  Announcement On Invoice
    compEDINumber: common.getLocalizedString("LBL", "lbl_compEDINumber"), //  Company EDI Number
    costGoodSoldCR: common.getLocalizedString("LBL", "lbl_costGoodSoldCR"), //  Cost of goods sold(CR)
    costGoodSoldDR: common.getLocalizedString("LBL", "lbl_costGoodSoldDR"), //  Cost of goods sold(DR)
    salesOrderLife: common.getLocalizedString("LBL", "lbl_salesOrderLife"), //  Sales Order Life (in days)

    unitpricevariance: common.getLocalizedString(
      "LBL",
      "lbl_unitpricevariance"
    ), //  Unit price variance tolerance
    approvalwheninvoice: common.getLocalizedString(
      "LBL",
      "lbl_approvalwheninvoice"
    ), //  Required approval when invoice overdue
    marketinggrpusers: common.getLocalizedString(
      "LBL",
      "lbl_marketinggrpusers"
    ), //  Marketing group users
    marketingmanagergrp: common.getLocalizedString(
      "LBL",
      "lbl_marketingmanagergrp"
    ), //  Marketing manager group
    salesmanusergrpid: common.getLocalizedString(
      "LBL",
      "lbl_salesmanusergrpid"
    ), //  Salesman user group ID
    salesmanagergrp: common.getLocalizedString("LBL", "lbl_salesmanagergrp"), //  Salesman manager group
    custEDIOrderQty: common.getLocalizedString("LBL", "lbl_custEDIOrderQty"), //  Customer EDI order qty in CTN
    bufferstocklifecycle: common.getLocalizedString(
      "LBL",
      "lbl_bufferstocklifecycle"
    ), //  Buffer stock life cycle
    consolidateinvoice: common.getLocalizedString(
      "LBL",
      "lbl_consolidateinvoice"
    ), //  Consolidate invoice

    allfilePath: common.getLocalizedString("LBL", "lbl_allfilePath"), //  All attachment file path
    promotiondata: common.getLocalizedString("LBL", "lbl_promotiondata"), //  Promotion data import path
    entdocrefPath: common.getLocalizedString("LBL", "lbl_entdocrefPath"), //  Entity document reference path
    prodphotoPath: common.getLocalizedString("LBL", "lbl_prodphotoPath"), //  Product photo path
    emailserverIP: common.getLocalizedString("LBL", "lbl_emailserverIP"), //  Email server IP address
    invoicePDF: common.getLocalizedString("LBL", "lbl_invoicePDF"), //  Invoice PDF export folder path
    reportfolderPath: common.getLocalizedString("LBL", "lbl_reportfolderPath"), //  Report folder path
    systemimgPath: common.getLocalizedString("LBL", "lbl_systemimgPath"), //  System image path
    systeminterPath: common.getLocalizedString("LBL", "lbl_systeminterPath"), //  System interface path
    systemlogPath: common.getLocalizedString("LBL", "lbl_systemlogPath"), //  System log path
    errorlogPath: common.getLocalizedString("LBL", "lbl_errorlogPath"), //  Error log file

    goodsreceipt: common.getLocalizedString("LBL", "lbl_goodsreceipt"), //  Goods Receipt
    SalesInovice: common.getLocalizedString("LBL", "lbl_SalesInovice"), //  Sales Inovice
    adjustment: common.getLocalizedString("LBL", "lbl_adjustment"), //  Adjustment
    salesreturn: common.getLocalizedString("LBL", "lbl_SalesReturn"), //  Sales Return
    transfer: common.getLocalizedString("LBL", "lbl_transfer"), //  Transfer

    exporttransaction: common.getLocalizedString(
      "LBL",
      "lbl_exporttransaction"
    ), //  Export Transaction
    systemsecurity: common.getLocalizedString("LBL", "lbl_systemsecurity"), //  System Security
    UserGrp: common.getLocalizedString("LBL", "lbl_UserGrp"), //  User Group
    UserGrpShopRightsMain: common.getLocalizedString(
      "LBL",
      "lbl_UserGrpShopRightsMain"
    ), //  User Group (Shop) Rights Mainenance
    shopusermaintenance: common.getLocalizedString(
      "LBL",
      "lbl_shopusermaintenance"
    ), // Shop User Maintenance
    engname: common.getLocalizedString("LBL", "lbl_engname"), // English Name
    shopusergrp: common.getLocalizedString("LBL", "lbl_shopusergrp"), // Shop User Group
    userSelection: common.getLocalizedString("LBL", "lbl_userSelection"), // User Selection
    GREnquiry: common.getLocalizedString("LBL", "lbl_GREnquiry"), // GR Enquiry
    POEnquiry: common.getLocalizedString("LBL", "lbl_POEnquiry"), // Purchase Order Enquiry
    closepo: common.getLocalizedString("LBL", "lbl_closepo"), // Close Purchase Order
    sel: common.getLocalizedString("LBL", "lbl_Sel"), // Sel

    //2020-12-01
    SalesTranEnquiry: common.getLocalizedString("LBL", "lbl_SalesTranEnquiry"), // Sales Transaction Enquiry
    pickinglist: common.getLocalizedString("LBL", "lbl_PickingList"), // Picking List
    convertPickingListtoInvoice: common.getLocalizedString(
      "LBL",
      "lbl_convertPickingListtoInvoice"
    ), // Convert PickingList to Invoice
    byselecelPLNum: common.getLocalizedString("LBL", "lbl_byselecelPLNum"), // By Select PL Num
    byhardCopy: common.getLocalizedString("LBL", "lbl_byhardCopy"), // By Hard Copy
    details: common.getLocalizedString("LBL", "lbl_Details"), // Details
    pickinglistno: common.getLocalizedString("LBL", "lbl_pickinglistno"), // Picking List No
    orderLoc: common.getLocalizedString("LBL", "lbl_orderLoc"), // Order Loc
    txRate: common.getLocalizedString("LBL", "lbl_txRate"), // Tx.Rate
    customerno: common.getLocalizedString("LBL", "lbl_customerno"), // Customer No
    pdcheque: common.getLocalizedString("LBL", "lbl_pdcheque"), // P.D. Cheque Details
    entitycreditref: common.getLocalizedString("LBL", "lbl_entitycreditref"), // Entity Credit Reference
    terms: common.getLocalizedString("LBL", "lbl_terms"), // Terms
    ACbal: common.getLocalizedString("LBL", "lbl_ACbal"), // A/C Bal
    balDate: common.getLocalizedString("LBL", "lbl_balDate"), // Bal Date
    onhold: common.getLocalizedString("LBL", "lbl_onhold"), // On Hold
    expiry: common.getLocalizedString("LBL", "lbl_expiry"), // Expiry
    entgrp: common.getLocalizedString("LBL", "lbl_entgrp"), // Ent.Group
    cnNo: common.getLocalizedString("LBL", "lbl_CNNo"), // CN No.
    cnDate: common.getLocalizedString("LBL", "lbl_CNDate"), // CN Date
    salesreturnremark: common.getLocalizedString(
      "LBL",
      "lbl_salesreturnremark"
    ), // Sales Return Remark
    salesreturnAppv: common.getLocalizedString("LBL", "lbl_salesreturnAppv"), // Sales Return Approval
    creditNotePrinting: common.getLocalizedString(
      "LBL",
      "lbl_creditNotePrinting"
    ), // Credit Note Printing
    newonly: common.getLocalizedString("LBL", "lbl_NewOnly"), // New Only
    entityitemref: common.getLocalizedString("LBL", "lbl_entityitemref"), // Entity Item Reference
    vendorinvoiceNo: common.getLocalizedString("LBL", "lbl_vendorinvoiceNo"), // Vendor Invoice No.
    vendorRef: common.getLocalizedString("LBL", "lbl_VendorRef"), // Vendor Ref.
    receive: common.getLocalizedString("LBL", "lbl_receive"), // Receive
    return: common.getLocalizedString("LBL", "lbl_return"), // Return
    grNo: common.getLocalizedString("LBL", "lbl_grNo"), // GR No.
    grtxSeq: common.getLocalizedString("LBL", "lbl_grtxSeq"), // GRTxSeq.
    stocktranEnquiry: common.getLocalizedString("LBL", "lbl_stocktranEnquiry"), // Stock Transaction Enquiry
    amount: common.getLocalizedString("LBL", "lbl_amount"), // Amt
    office: common.getLocalizedString("LBL", "lbl_Office"), // Office
    payment: common.getLocalizedString("LBL", "lbl_payment"), // Payment
    cate: common.getLocalizedString("LBL", "lbl_cate"), // Cate
    productLineInCharge: common.getLocalizedString(
      "LBL",
      "lbl_productLineInCharge"
    ), // Product Line In Charge
    productGrp: common.getLocalizedString("LBL", "lbl_productGrp"), // Product Group
    admin: common.getLocalizedString("LBL", "lbl_admin"), // ADMIN
    loadstocktakeresult: common.getLocalizedString(
      "LBL",
      "lbl_loadstocktakeresult"
    ), // Load Stock Take Result
    updateStockTakeVariance: common.getLocalizedString(
      "LBL",
      "lbl_updateStockTakeVariance"
    ), // Update Stock Take Variance
    on: common.getLocalizedString("LBL", "lbl_On"), // On
    showAllItems: common.getLocalizedString("LBL", "lbl_showAllItems"), // Show All Items
    stockTakeTx: common.getLocalizedString("LBL", "lbl_stockTakeTx"), // Stock Take Tx

    //2020-12-14
    dataintegrity: common.getLocalizedString("LBL", "lbl_dataintegrity"), // Data Integrity
    itemintransaction: common.getLocalizedString(
      "LBL",
      "lbl_itemintransaction"
    ), // Item in Transaction
    lastmovement: common.getLocalizedString("LBL", "lbl_lastmovement"), // Last movement on or before
    manualselect: common.getLocalizedString("LBL", "lbl_manualselect"), // Manual Select (will apply to all items)
    recalcostonly: common.getLocalizedString("LBL", "lbl_recalcostonly"), // Re-calculate cost only
    stockmovementAnalysis: common.getLocalizedString(
      "LBL",
      "lbl_stockmovementAnalysis"
    ), // Stock Movement Analysis
    group: common.getLocalizedString("LBL", "lbl_group"), // Group
    openingqty: common.getLocalizedString("LBL", "lbl_openingqty"), // Opening Qty
    openingamt: common.getLocalizedString("LBL", "lbl_openingamt"), // Opening Amt
    GRqty: common.getLocalizedString("LBL", "lbl_GRqty"), // GR Qty
    GRamt: common.getLocalizedString("LBL", "lbl_GRamt"), // GR Amt
    crnCOGS: common.getLocalizedString("LBL", "lbl_crnCOGS"), // CrnCOGS
    adjust: common.getLocalizedString("LBL", "lbl_adjust"), // Adjust
    closing: common.getLocalizedString("LBL", "lbl_closing"), // Closing
    invDisc: common.getLocalizedString("LBL", "lbl_invDisc"), // Inv.Disc
    txSeq: common.getLocalizedString("LBL", "lbl_txSeq"), // Tx.Seq
    soLine: common.getLocalizedString("LBL", "lbl_soLine"), // SO Line
    sOLine: common.getLocalizedString("LBL", "lbl_soLine"), // SO Line 为了配合后端返回数据 2023-09-23

    slsManCode: common.getLocalizedString("LBL", "lbl_SlsmanCode"), // SalesMan Code
    slsCode: common.getLocalizedString("LBL", "lbl_SlsmanCode"), // SalesMan Code 为了配合后端返回数据 2023-09-23
    ValidDays: common.getLocalizedString("LBL", "lbl_ValidDays"),
    seriesSelection: common.getLocalizedString("LBL", "lbl_seriesSelection"), // Series Selection
    entityLocationSelection: common.getLocalizedString(
      "LBL",
      "lbl_entityLocationSelection"
    ), // Entity Location Selection

    addToCart: common.getLocalizedString("LBL", "lbl_addToCart"), // Add to Cart
    // newPassword: common.getLocalizedString("LBL", "lbl_newPassword"), // New Password
    retypeNewPassword: common.getLocalizedString(
      "LBL",
      "lbl_retypeNewPassword"
    ), //Retype New Password
    required: common.getLocalizedString("LBL", "lbl_required"), // Required
    min8Characters: common.getLocalizedString("LBL", "lbl_min8Characters"), // Min 8 characters
    passwordEnteredDoesntMatch: common.getLocalizedString(
      "LBL",
      "lbl_passwordEnteredDoesntMatch"
    ), // Password entered doesn't match
    // remark: common.getLocalizedString("LBL", "lbl_remark"), // Remark
    total: common.getLocalizedString("LBL", "lbl_total"), // Total
    orderNumber: common.getLocalizedString("LBL", "lbl_orderNumber"), // Order Number
    shopName: common.getLocalizedString("LBL", "lbl_shopName"), // Shop Name
    shopNumber: common.getLocalizedString("LBL", "lbl_shopNumber"), // Shop Number 铺号
    merchantNumber: common.getLocalizedString("LBL", "lbl_merchantNumber"), // merchant Number商户编号
    by: common.getLocalizedString("LBL", "lbl_by"), // By
    detail: common.getLocalizedString("LBL", "lbl_detail"), // Detail
    foodexpiryDate: common.getLocalizedString("LBL", "lbl_FoodExpiryDate"), // Food Expiry Date
    expiryDate: common.getLocalizedString("LBL", "lbl_ExpiryDate"), // Expiry Date
    confirmOrder: common.getLocalizedString("LBL", "lbl_confirmOrder"), // Confirm Order
    cancelOrder: common.getLocalizedString("LBL", "lbl_cancelOrder"), // Cancel Order
    exRate: common.getLocalizedString("LBL", "lbl_ExRate"), // Exchange Rate
    locationlbl: common.getLocalizedString("LBL", "lbl_location"), // Location
    districtSelection: common.getLocalizedString(
      "LBL",
      "lbl_districtSelection"
    ), // District Selection
    CloseAmt: common.getLocalizedString("LBL", "lbl_CloseAmt"), // Closing Amount
    CloseQty: common.getLocalizedString("LBL", "lbl_CloseQty"), // Closing Qty
    AdjQty: common.getLocalizedString("LBL", "lbl_AdjQty"), // Adjust Qty
    AdjAmt: common.getLocalizedString("LBL", "lbl_AdjAmt"), // Adjust Amount
    OpenQty: common.getLocalizedString("LBL", "lbl_OpenQty"), // Opening Qty
    OpenAmt: common.getLocalizedString("LBL", "lbl_OpenAmt"), // Opening Amount
    customerSelection: common.getLocalizedString(
      "LBL",
      "lbl_customerSelection"
    ), // Customer Selection
    OSPOQty: common.getLocalizedString("LBL", "lbl_OSPOQty"), // OSPO Qty
    OSPOAltQty: common.getLocalizedString("LBL", "lbl_OSPOAltQty"), // OSPO Alt Qty
    TotAltQty: common.getLocalizedString("LBL", "lbl_TotAltQty"), // Total Alt Qty
    Note1: common.getLocalizedString("LBL", "lbl_Note1"), // Note1
    Note2: common.getLocalizedString("LBL", "lbl_Note2"), // Note2
    ShipEntNum: common.getLocalizedString("LBL", "lbl_ShipEntNum"), // Ship Entity No.
    areaSelection: common.getLocalizedString("LBL", "lbl_areaSelection"), // Area Selection
    language: common.getLocalizedString("LBL", "lbl_Lang"), // Language
    invoiceref: common.getLocalizedString("LBL", "lbl_invoiceref"), // Invoice Ref.
    InvoiceRefSelection: common.getLocalizedString(
      "LBL",
      "lbl_InvoiceRefSelection"
    ), // Invoice Reference
    AfrAllDis: common.getLocalizedString("LBL", "lbl_AfrAllDis"), // AfrAllDis (After All Discount)
    netqty: common.getLocalizedString("LBL", "lbl_netqty"), // Net Qty

    PRNum: common.getLocalizedString("LBL", "lbl_PRNum"), // PR No.
    PRDate: common.getLocalizedString("LBL", "lbl_ReturnDate"), // Return Date
    ContraTxNum: common.getLocalizedString("LBL", "lbl_ContraTxNum"), // Contra No.
    importItemPriceClass: common.getLocalizedString(
      "LBL",
      "lbl_importItemPriceClass"
    ), // Import Item Price Class
    ErrMsg: common.getLocalizedString("LBL", "lbl_ErrMsg"), // Error
    OutstandingSOEnquiry: common.getLocalizedString(
      "LBL",
      "lbl_OutstandingSOEnquiry"
    ), // Outstanding SO Enquiry
    //Bundle  Item
    shops: common.getLocalizedString("LBL", "lbl_shops"), // Shops
    shopLine: common.getLocalizedString("LBL", "lbl_ShopLine"), // Shop Line
    shopNo: common.getLocalizedString("LBL", "lbl_ShopNum"), // Shop No.
    shortName: common.getLocalizedString("LBL", "lbl_ShortName"), // Short Name
    receiptLang: common.getLocalizedString("LBL", "lbl_ReceiptLang"), // Receipt Lang
    english: common.getLocalizedString("LBL", "lbl_Eng"), // English
    chinese: common.getLocalizedString("LBL", "lbl_Chi"), // Chinese
    bundleitem: common.getLocalizedString("LBL", "lbl_bundleitem"), // Bundle Item
    bundleID: common.getLocalizedString("LBL", "lbl_bundleID"), // Bundle ID
    // MixandMatchSetting
    MixandMatchSetting: common.getLocalizedString(
      "LBL",
      "lbl_MixandMatchSetting"
    ), //Mix and Match Setting
    ruleID: common.getLocalizedString("LBL", "lbl_ruleID"), //Rule ID
    setting: common.getLocalizedString("LBL", "lbl_setting"), //Setting
    effective: common.getLocalizedString("LBL", "lbl_effective"), //Effective
    endofInvoice: common.getLocalizedString("LBL", "lbl_endofInvoice"), //End Of Invoice
    allmonths: common.getLocalizedString("LBL", "lbl_allmonths"), //All Months
    months: common.getLocalizedString("LBL", "lbl_months"), //Months
    wholeday: common.getLocalizedString("LBL", "lbl_wholeday"), //Whole Day
    oclock: common.getLocalizedString("LBL", "lbl_oclock"), //O'clock
    endofmonth: common.getLocalizedString("LBL", "lbl_endofmonth"), //End Of Month
    weekday: common.getLocalizedString("LBL", "lbl_weekday"), //WeekDay
    daysMM: common.getLocalizedString("LBL", "lbl_daysMM"), //Days
    itemRelationship: common.getLocalizedString("LBL", "lbl_itemRelationship"), //Item RelationShip
    allitems: common.getLocalizedString("LBL", "lbl_allitems"), //All items
    any: common.getLocalizedString("LBL", "lbl_any"), //Any
    value: common.getLocalizedString("LBL", "lbl_value"), //Value
    Disc: common.getLocalizedString("LBL", "lbl_Disc"), //Disc %
    DiscAmt: common.getLocalizedString("LBL", "lbl_DiscAmt"), //Disc Amt
    exactAmt: common.getLocalizedString("LBL", "lbl_exactAmt"), //Exact Amt
    Condition: common.getLocalizedString("LBL", "lbl_Condition"), //Condition
    mmRuleSelection: common.getLocalizedString("LBL", "lbl_mmRuleSelection"), //Rule ID Selection

    //19-08-2021
    ConvertBatchSOToInvoice: common.getLocalizedString(
      "LBL",
      "lbl_ConvertBatchSOToInvoice"
    ), //Convert Batch SO To Invoice
    BatchNo: common.getLocalizedString("LBL", "lbl_BatchNo"), //batch#批次号
    oldBatch: common.getLocalizedString("LBL", "lbl_OldBatch"), //old batch
    curBatch: common.getLocalizedString("LBL", "lbl_CurBatch"), //current batch
    isPxFixed: common.getLocalizedString("LBL", "lbl_isPxFixed"), //isPxFixed

    //30-10-2021
    labelTemplateCreation: common.getLocalizedString(
      "LBL",
      "lbl_LabelTemplateCreation"
    ), //Label TemplateCreation
    labelTemplateNo: common.getLocalizedString("LBL", "lbl_LabelTemplateNo"), //Label TemplateNo
    nameEng: common.getLocalizedString("LBL", "lbl_NameEng"), //Name Eng
    nameChi: common.getLocalizedString("LBL", "lbl_NameChi"), //Name Chi
    design: common.getLocalizedString("LBL", "lbl_Design"), //Design
    filedSize: common.getLocalizedString("LBL", "lbl_FiledSize"), //Filed Size
    labelDisplay: common.getLocalizedString("LBL", "lbl_LabelDisplay"), //Label Display
    filedLocation: common.getLocalizedString("LBL", "lbl_FiledLocation"), //Filed Location
    x: common.getLocalizedString("LBL", "lbl_X"), //X
    y: common.getLocalizedString("LBL", "lbl_Y"), //Y
    filedWidth: common.getLocalizedString("LBL", "lbl_FiledWidth"), //Filed Width
    filedHeight: common.getLocalizedString("LBL", "lbl_FiledHeight"), //Filed Height
    labelHeight: common.getLocalizedString("LBL", "lbl_LabelHeight"), //Filed Label Height
    labelWidth: common.getLocalizedString("LBL", "lbl_LabelWidth"), //Filed Label Width
    font: common.getLocalizedString("LBL", "lbl_Font"), //Filed Label Height
    fontSize: common.getLocalizedString("LBL", "lbl_FontSize"), //Filed Label Width
    labelSize: common.getLocalizedString("LBL", "lbl_LabelSize"), //Label Size
    controlName: common.getLocalizedString("LBL", "lbl_ControlName"), //Label Control Name
    engDesc: common.getLocalizedString("LBL", "lbl_EngDesc"), //Label Eng Desc
    chiDesc: common.getLocalizedString("LBL", "lbl_ChiDesc"), //Label Chi Desc
    japanDes: common.getLocalizedString("LBL", "lbl_JapanDesc"), //Label Japan Desc
    jpYen: common.getLocalizedString("LBL", "lbl_JPYen"), //Label Japan Desc
    eAbrv: common.getLocalizedString("LBL", "lbl_EAbrv"), //Abv.(Eng.):
    cAbrv: common.getLocalizedString("LBL", "lbl_CAbrv"), //Abv.(Trad. Chin.):
    jPAbrv: common.getLocalizedString("LBL", "lbl_JPAbrv"), //Abv.(Jpn.):
    bin1: common.getLocalizedString("LBL", "lbl_Bin1"), //Bin1
    cate1: common.getLocalizedString("LBL", "lbl_Cate1"), //Category 1
    generalInfo: common.getLocalizedString("LBL", "lbl_GeneralInfo"), //General Information
    recordApprove: common.getLocalizedString("LBL", "lbl_recordApprove"), //General Information
    recordConfirm: common.getLocalizedString("LBL", "lbl_recordConfirm"), //General Information
    labelTemplateID: common.getLocalizedString("LBL", "lbl_LabelTemplateID"), //Label Template Id
    nurList: common.getLocalizedString("LBL", "lbl_NurList"), //Nutrition List
    storage: common.getLocalizedString("LBL", "lbl_Storage"), //storage
    manufacturer: common.getLocalizedString("LBL", "lbl_Manufacturer"), //manufacturer
    manufacturerAddr: common.getLocalizedString("LBL", "lbl_ManufacturerAddr"), //storage
    importBy: common.getLocalizedString("LBL", "lbl_ImportBy"), //ImportBy
    phone: common.getLocalizedString("LBL", "lbl_Phone"), //Phone
    nutrition: common.getLocalizedString("LBL", "lbl_Nutrition"), //Nutrition
    title1: common.getLocalizedString("LBL", "lbl_Title1"), //title1
    title2: common.getLocalizedString("LBL", "lbl_Title2"), //title2
    energy: common.getLocalizedString("LBL", "lbl_Energy"), //energy
    protein: common.getLocalizedString("LBL", "lbl_Protein"), //Protein
    totalFat: common.getLocalizedString("LBL", "lbl_TotalFat"), //totalFat
    saturatedFat: common.getLocalizedString("LBL", "lbl_SaturatedFat"), //SaturatedFat
    transFat: common.getLocalizedString("LBL", "lbl_TransFat"), //TransFat
    carbohydrates: common.getLocalizedString("LBL", "lbl_Carbohydrates"), //Carbohydrates
    sugars: common.getLocalizedString("LBL", "lbl_Sugars"), //sugars
    sodium: common.getLocalizedString("LBL", "lbl_Sodium"), //sodium
    barcodeLabel: common.getLocalizedString("LBL", "lbl_BarcodeLabel"), //Barcode
    expiryManufact: common.getLocalizedString("LBL", "lbl_expiryManufact"), //expiryManufact
    expiryManufactDateDesc: common.getLocalizedString(
      "LBL",
      "lbl_expiryManufactDateDesc"
    ), //expiryManufactDateDesc

    quote: common.getLocalizedString("LBL", "lbl_Quotation"),
    quoteDesc: common.getLocalizedString("LBL", "lbl_QuoteDesc"),
    customerName: common.getLocalizedString("LBL", "lbl_CustName"),
    items: common.getLocalizedString("LBL", "lbl_Item"),
    jobTitle: common.getLocalizedString("LBL", "lbl_jobTitle"),
    valid: common.getLocalizedString("LBL", "lbl_valid"),
    rem: common.getLocalizedString("LBL", "lbl_Remark"),
    packaging: common.getLocalizedString("LBL", "lbl_Packing"),
    unitRate: common.getLocalizedString("LBL", "lbl_unitRate"),
    qtyFr: common.getLocalizedString("LBL", "lbl_qtyFr"),
    qtyTo: common.getLocalizedString("LBL", "lbl_qtyTo"),
    forItems: common.getLocalizedString("LBL", "lbl_forItems"),
    noProductsFound: common.getLocalizedString("LBL", "lbl_noProductsFound"),
    PIC: common.getLocalizedString("LBL", "lbl_PIC"), //負責人
    itemSet: common.getLocalizedString("LBL", "lbl_ItemSet"), //物料單
    parentItem: common.getLocalizedString("LBL", "lbl_ParentItem"), //父项

    fiscalYear: common.getLocalizedString("LBL", "fiscalYear"), //fiscalYear
    calendarYear: common.getLocalizedString("LBL", "calendarYear"),

    loading: common.getLocalizedString("LBL", "LBL_Loading"),

    // 2026-01-07
    MarketInfo: common.getLocalizedString("LBL", "MarketInfo"),
    SKUDesc: common.getLocalizedString("LBL", "SKUDesc"),
    SKU: common.getLocalizedString("LBL", "SKU"),
    SKUPrice: common.getLocalizedString("LBL", "SKUPrice"),
    SKUUrl: common.getLocalizedString("LBL", "SKUUrl"),
    RequiredWords: common.getLocalizedString("LBL", "RequiredWords"),
    OptionalWords: common.getLocalizedString("LBL", "OptionalWords"),
    ManualUrl: common.getLocalizedString("LBL", "ManualUrl"),
    ManualDesc: common.getLocalizedString("LBL", "ManualDesc"),
    ManualPrice: common.getLocalizedString("LBL", "ManualPrice"),
    AutoCheck: common.getLocalizedString("LBL", "AutoCheck"),
    AutoUrl: common.getLocalizedString("LBL", "AutoUrl"),
    AutoDesc: common.getLocalizedString("LBL", "AutoDesc"),
    AutoPrice: common.getLocalizedString("LBL", "AutoPrice"),
    AutoMsg: common.getLocalizedString("LBL", "AutoMsg"),
    CateName: common.getLocalizedString("LBL", "CateName"),
    PageUrl: common.getLocalizedString("LBL", "PageUrl"),
    EnterTxtSearch: common.getLocalizedString("LBL", "EnterTxtSearch"),
    SelectSiteSKU: common.getLocalizedString("LBL", "SelectSiteSKU"), //Select {siteName} SKU
    CompetitorLowerPrice: common.getLocalizedString(
      "LBL",
      "CompetitorLowerPrice"
    ),
    StkBalEnqMulti: common.getLocalizedString("LBL", "StkBalEnqMulti"),
    NA: common.getLocalizedString("LBL", "NA"),
    PrioritySelect: common.getLocalizedString("LBL", "PrioritySelect"),
    ProductTot: common.getLocalizedString("LBL", "ProductTot"),
    CompareTot: common.getLocalizedString("LBL", "CompareTot"),
    SaleOrder: common.getLocalizedString("LBL", "SaleOrder"),
    MoldSO: common.getLocalizedString("LBL", "MoldSO"),
    GrpByDeliveryTime: common.getLocalizedString("LBL", "GrpByDeliveryTime"),
    DeliverySummary: common.getLocalizedString("LBL", "DeliverySummary"),

    // 2023-12-20
    month: common.getLocalizedString("LBL", "Month"), //月
    months: {
      Jan: common.getLocalizedString("LBL", "Jan"), // 1月
      Feb: common.getLocalizedString("LBL", "Feb"), // 2月
      Mar: common.getLocalizedString("LBL", "Mar"), // 3月,
      Apr: common.getLocalizedString("LBL", "Apr"), // 4月
      May: common.getLocalizedString("LBL", "May"), // 5月
      Jun: common.getLocalizedString("LBL", "Jun"), // 6月
      Jul: common.getLocalizedString("LBL", "Jul"), // 7月
      Aug: common.getLocalizedString("LBL", "Aug"), // 8月
      Sep: common.getLocalizedString("LBL", "Sep"), // 9月
      Oct: common.getLocalizedString("LBL", "Oct"), // 10月
      Nov: common.getLocalizedString("LBL", "Nov"), // 11月
      Dec: common.getLocalizedString("LBL", "Dec") // 12月
    },
    week: common.getLocalizedString("LBL", "Week"), //周
    weeks: {
      Sun: common.getLocalizedString("LBL", "Sun"), // 星期日,
      Mon: common.getLocalizedString("LBL", "Mon"), // 星期一,
      Tue: common.getLocalizedString("LBL", "Tue"), // 星期二,
      Wed: common.getLocalizedString("LBL", "Wed"), // 星期三,
      Thu: common.getLocalizedString("LBL", "Thu"), // 星期四,
      Fri: common.getLocalizedString("LBL", "Fri"), // 星期五,
      Sat: common.getLocalizedString("LBL", "Sat"), // 星期六,
      sSun: common.getLocalizedString("LBL", "sSun"), // 周日,
      sMon: common.getLocalizedString("LBL", "sMon"), // 周一,
      sTue: common.getLocalizedString("LBL", "sTue"), // 周二,
      sWed: common.getLocalizedString("LBL", "sWed"), // 周三,
      sThu: common.getLocalizedString("LBL", "sThu"), // 周四,
      sFri: common.getLocalizedString("LBL", "sFri"), // 周五,
      sSat: common.getLocalizedString("LBL", "sSat"), // 周六,
      mSun: common.getLocalizedString("LBL", "mSun"), // 日,
      mMon: common.getLocalizedString("LBL", "mMon"), // 一,
      mTue: common.getLocalizedString("LBL", "mTue"), // 二,
      mWed: common.getLocalizedString("LBL", "mWed"), // 三,
      mThu: common.getLocalizedString("LBL", "mThu"), // 四,
      mFri: common.getLocalizedString("LBL", "mFri"), // 五,
      mSat: common.getLocalizedString("LBL", "mSat") // 六,
    },

    GoodsPicked: common.getLocalizedString("LBL", "GoodsPicked"), // Goods Picked
    RequireSerial: common.getLocalizedString("LBL", "RequireSerial"), // Require Serial 需要序列号 2026-08-13
    UpdateStatusWhenPrint: common.getLocalizedString("LBL", "UpdateStatusWhenPrint"), // Update Status When Print 打印时更新状态 2026-08-17
  },

  Btn: {
    yes: common.getLocalizedString("BTN", "Button.Yes"), // Yes
    no: common.getLocalizedString("BTN", "Button.No"), // No
    cancle: common.getLocalizedString("BTN", "btn_Cancle"), //Cancle
    select: common.getLocalizedString("BTN", "btn_Select"), // Select
    search: common.getLocalizedString("BTN", "btn_Search"), // Search
    clear: common.getLocalizedString("BTN", "btn_Clear"), // Clear
    enquire: common.getLocalizedString("BTN", "btn_Enquire"), // Enquire
    exit: common.getLocalizedString("BTN", "btn_exit"), // Exit
    freezeColumn: common.getLocalizedString("BTN", "btn_freezeColumn"), // Freeze Column
    relatedAccount: common.getLocalizedString("BTN", "btn_relatedAccount"), // Related Account
    remarks: common.getLocalizedString("BTN", "btn_remarks"), // Remarks
    selectAll: common.getLocalizedString("BTN", "btn_SelectAll"), // Select All
    deselectAll: common.getLocalizedString("BTN", "btn_DeselectAll"), // Deselect All
    transactionDetails: common.getLocalizedString(
      "BTN",
      "btn_transactionDetails"
    ), // Transaction Details
    ChangeToPending: common.getLocalizedString("BTN", "btn_ChangeToPending"), // Change To Pending
    Save: common.getLocalizedString("BTN", "btn_Save"), // Save
    cancel: common.getLocalizedString("BTN", "btn_Cancel"), // Cancel
    submit: common.getLocalizedString("BTN", "btn_Submit"), // Submit
    Download: common.getLocalizedString("BTN", "btn_Download"), // Download
    Update: common.getLocalizedString("BTN", "btn_Update"), // Update
    Verify: common.getLocalizedString("BTN", "btn_Verify"), // Verify
    Confirmed: common.getLocalizedString("BTN", "btn_Confirmed"), // Confirmed
    Help: common.getLocalizedString("BTN", "btn_Help"), // Help

    setasdefault: common.getLocalizedString("BTN", "btn_setasdefault"), // Set As Default
    delete: common.getLocalizedString("BTN", "btn_delete"), // Delete
    allRec: common.getLocalizedString("BTN", "btn_AllRec"), // All Record

    //22-09-2020
    ChangePwd: common.getLocalizedString("BTN", "btn_ChangePwd"), // Change Password
    add: common.getLocalizedString("BTN", "btn_add"), // Add
    load: common.getLocalizedString("BTN", "btn_Load"), // Load
    Edit: common.getLocalizedString("BTN", "btn_Edit"), // Edit

    changeAddress: common.getLocalizedString("BTN", "btn_changeAddress"),
    changeLanguage: common.getLocalizedString("BTN", "btn_changeLanguage"), // Change Language
    // changePassword: common.getLocalizedString("BTN", "btn_changePassword"), // Change Password
    logout: common.getLocalizedString("BTN", "Login.Logout"),
    updateRecord: common.getLocalizedString("BTN", "btn_UpdateRecord"), //update record
    deleteRecord: common.getLocalizedString("BTN", "btn_DeleteRecord"), //delete record
    addChildItem: common.getLocalizedString("BTN", "btn_AddChildItem"), //add child item
    export: common.getLocalizedString("BTN", "btn_Export") // Export
  },
  Msg: {
    noRecords: common.getLocalizedString("MSG", "msg_ErrNoRecords"), // No records !
    deleteRecord: common.getLocalizedString("MSG", "msg_Del_Rec"), // Delete the record
    uploadFile: common.getLocalizedString("MSG", "msg_FileUpload"), // Upload file
    dropFileToUpload: common.getLocalizedString("MSG", "msg_DropFileToUpload"), // Drop files to Upload
    recordSaved: common.getLocalizedString("MSG", "msg_RecordSaved"), // Record Saved.
    recordUpdated: common.getLocalizedString("MSG", "msg_RecordUpdated"), // Record has been updated.
    recordConfirmed: common.getLocalizedString("MSG", "msg_RecordConfirmed"), // Record has been Confirmed.
    msg_RecordApproved: common.getLocalizedString("MSG", "msg_RecordApproved"), // Record has been Approved.
    msg_RecordRejected: common.getLocalizedString("MSG", "msg_RecordRejected"), // Record has been Rejected.
    noSelection: common.getLocalizedString("MSG", "msg_No_Selection"), // Please select at least one record to delete!
    //Shops 页面
    selectShopLine: common.getLocalizedString(
      "MSG",
      "msg_SelectShopLine"      
    ), // Please select a shop line first
    selectShop: common.getLocalizedString(
      "MSG",
      "msg_SelectShop"
    ), // Please select a shop first
    shopLineRequired: common.getLocalizedString(
      "MSG",
      "msg_ShopLineRequired"
    ), // Shop Line is required
    shopNoRequired: common.getLocalizedString(
      "MSG",
      "msg_ShopNoRequired"
    ), // Shop No. is required
    loadFailed: common.getLocalizedString(
      "MSG",
      "msg_LoadFailed"
    ), // Load failed
    selectEntity: common.getLocalizedString(
      "MSG",
      "msg_SelectEntity"
    ), // Please select an entity first
    noEntLoc: common.getLocalizedString(
      "MSG",
      "msg_NoEntLoc"
    ), // No location found for this entity
    noPrintSelection: common.getLocalizedString("MSG", "msg_No_PrintSelection"), // Please select at least one record to print!
    noPostSelection: common.getLocalizedString("MSG", "msg_No_PostSelection"), // Please select at least one record to post!
    noUnpostSelection: common.getLocalizedString(
      "MSG",
      "msg_No_UnpostSelection"
    ), // Please select at least one record to post!
    recordDeleted: common.getLocalizedString("MSG", "msg_RecordDeleted"), // Record has been Deleted.
    errRecordDeleted: common.getLocalizedString("MSG", "msg_errRecordDeleted"), // Record  Deleted Fail.
    exportFileSuccess: common.getLocalizedString(
      "MSG",
      "msg_ExportFileSuccess"
    ), // File exported successfully!
    selectExcel: common.getLocalizedString("MSG", "msg_SelectExcel"), // Please select excel file to import!
    fileSizeExceeds: common.getLocalizedString("MSG", "msg_FileSizeExceeds"), //File size exceeds!
    countryCodeRequired: common.getLocalizedString(
      "MSG",
      "msg_CountryCodeRequired"
    ), // Country code is required!
    countryCodevalue: common.getLocalizedString("MSG", "msg_countryCodevalue"), // Country code can not enter more than 5 Letters!
    countryNamevalue: common.getLocalizedString("MSG", "msg_countryNamevalue"), // Country Name can not enter more than 30 Letters!
    districtCodevalue: common.getLocalizedString(
      "MSG",
      "msg_districtCodevalue"
    ), // District Code can not enter more than 5 Letters!
    areaCodevalue: common.getLocalizedString("MSG", "msg_areaCodevalue"), // Area Code can not enter more than 5 Letters!
    areaDescvalue: common.getLocalizedString("MSG", "msg_areaDescvalue"), // Area Decription  can not enter more than 40 Letters!
    iddvalue: common.getLocalizedString("MSG", "msg_iddvalue"), // IDD can not enter more than 5 Letters!
    curCodevalue: common.getLocalizedString("MSG", "msg_curCodevalue"), // Currency code can not enter more than 3 Letters!

    countryNameRequired: common.getLocalizedString(
      "MSG",
      "msg_CountryNameRequired"
    ), // Country name is required!
    remarkNotEmpty: common.getLocalizedString("MSG", "msg_Remark_NotEmpty"), // Remark is required!
    iDDRequired: common.getLocalizedString("MSG", "msg_IDDRequired"), // IDD is required!
    currencyNameRequired: common.getLocalizedString(
      "MSG",
      "msg_currencyNameRequired"
    ), // Currency Name is required!
    currencyCodeRequired: common.getLocalizedString(
      "MSG",
      "msg_CurrencyCodeRequired"
    ), // Currency code is required!
    baseunitRequired: common.getLocalizedString("MSG", "msg_baseunitRequired"), // Base Unit is required!
    deptCodeRequired: common.getLocalizedString(
      "MSG",
      "msg_DepartmentCodeRequired"
    ), // Department code is required!
    deptNameRequired: common.getLocalizedString(
      "MSG",
      "msg_DepartmentNameRequired"
    ), // Department name is required!
    brandCodeRequired: common.getLocalizedString(
      "MSG",
      "msg_BrandCodeRequired"
    ), // Brand code is required!
    brandCodevalue: common.getLocalizedString("MSG", "msg_brandCodevalue"), // Brand code can not enter more than 10 Letters!
    brandDescRequired: common.getLocalizedString(
      "MSG",
      "msg_BrandDescRequired"
    ), // Brand description is required!
    chineseDescRequired: common.getLocalizedString(
      "MSG",
      "msg_ChineseDescRequired"
    ), // Chinese description is required!
    cate2CodeRequired: common.getLocalizedString(
      "MSG",
      "msg_Cate2CodeRequired"
    ), // Category 2 code is required!
    engDescRequired: common.getLocalizedString("MSG", "msg_EngDescRequired"), // English description is required!
    cate1CodeRequired: common.getLocalizedString(
      "MSG",
      "msg_Cate1CodeRequired"
    ), // Category 1 code is required!
    markUpRequired: common.getLocalizedString("MSG", "msg_MarkUpRequired"), // Mark up is  required!
    cate1DiscRequired: common.getLocalizedString(
      "MSG",
      "msg_Cate1DiscountRequired"
    ), // Category 1 discount is required!
    cate1DiscDecimal: common.getLocalizedString(
      "MSG",
      "msg_Cate1DiscountDecimal"
    ), // Category 1 discount may contain digits and decimal point!
    indDiscRequired: common.getLocalizedString(
      "MSG",
      "msg_IndDiscountRequired"
    ), // Ind discount is required!
    indDiscDecimal: common.getLocalizedString("MSG", "msg_IndDiscountDecimal"), // Ind discount may contain digits and decimal point!
    MOQRequired: common.getLocalizedString("MSG", "msg_MOQRequired"), // MOQ is required!
    MOQDigit: common.getLocalizedString("MSG", "msg_MOQDigit"), // MOQ must be numeric!
    COQRequired: common.getLocalizedString("MSG", "msg_COQRequired"), // COQ is required!
    COQDigit: common.getLocalizedString("MSG", "msg_COQDigit"), // COQ  must be numeric!
    refGrp1Required: common.getLocalizedString("MSG", "msg_refGrp1Required"), // Reference Group 1 is required!
    refGrp2Required: common.getLocalizedString("MSG", "msg_refGrp2Required"), // Reference Group 2 is required!
    idleAllowRequired: common.getLocalizedString(
      "MSG",
      "msg_IdleAllowRequired"
    ), // Idle is required!
    idleAllowDigit: common.getLocalizedString("MSG", "msg_IdleAllowDigit"), // Idle must be numeric!
    minChargeRequired: common.getLocalizedString(
      "MSG",
      "msg_MinimumChargeRequired"
    ), // Minimum charge is required!
    minChargeDecimal: common.getLocalizedString(
      "MSG",
      "msg_MinimumChargeDecimal"
    ), // Minimum charge may contain digits and decimal point!
    itemNumberRequired: common.getLocalizedString(
      "MSG",
      "msg_ItemNumberRequired"
    ), // Item number is required!
    itemNumValid: common.getLocalizedString("MSG", "ItemNumValid"), // Item number is required!
    shelfLifeRequired: common.getLocalizedString(
      "MSG",
      "msg_ShelfLifeRequired"
    ), // Shelf life is required!
    lengthRequired: common.getLocalizedString("MSG", "msg_LengthRequired"), // Length is required!
    widthRequired: common.getLocalizedString("MSG", "msg_WidthRequired"), // Width is required!
    heightRequired: common.getLocalizedString("MSG", "msg_HeightRequired"), // Height is required!
    lastSlsDtRequired: common.getLocalizedString(
      "MSG",
      "msg_LastSlsDtRequired"
    ), // Last sales date is required!
    lastRecDtRequired: common.getLocalizedString(
      "MSG",
      "msg_LastRecDtRequired"
    ), // Last receive date is required!
    retailYenRequired: common.getLocalizedString(
      "MSG",
      "msg_RetailYenRequired"
    ), // Retail is required!
    prodLeadTimeRequired: common.getLocalizedString(
      "MSG",
      "msg_ProdLeadTimeRequired"
    ), // Production lead time is required!
    FOBRequired: common.getLocalizedString("MSG", "msg_FOBRequired"), // FOB is required!
    GWeightRequired: common.getLocalizedString("MSG", "msg_GWeightRequired"), // Gross weight is required!
    NWeightRequired: common.getLocalizedString("MSG", "msg_NWeightRequired"), // Net weight is required!
    expiryDtRequired: common.getLocalizedString("MSG", "msg_ExpiryDtRequired"), // Expiry date is required!
    districtCodeRequired: common.getLocalizedString(
      "MSG",
      "msg_DistrictCodeRequired"
    ), // District code is required!
    areaCodeRequired: common.getLocalizedString("MSG", "msg_areaCodeRequired"), // Area Code is required!
    areaDescRequired: common.getLocalizedString("MSG", "msg_AreaDescRequired"), // Area descreption is required!
    areaChineseDescRequired: common.getLocalizedString(
      "MSG",
      "msg_AreaChineseDescRequired"
    ), //Area chinese description is required
    binSeqRequired: common.getLocalizedString("MSG", "msg_BinSeqRequired"), // Bin sequence is required!
    binNumRequired: common.getLocalizedString("MSG", "msg_BinNumRequired"), // Bin number is required!
    binDescRequired: common.getLocalizedString("MSG", "msg_BinDescRequired"), // Bin description is required!
    seriesCodeRequired: common.getLocalizedString(
      "MSG",
      "msg_SeriesCodeRequired"
    ), // Series code is required!
    seriesDescRequired: common.getLocalizedString(
      "MSG",
      "msg_SeriesDescRequired"
    ), // Series description is required!
    seriesGPRequired: common.getLocalizedString("MSG", "msg_seriesGPRequired"), // GP is required!
    locationRequired: common.getLocalizedString("MSG", "msg_LocationRequired"), // Location is required!
    locationDescRequired: common.getLocalizedString(
      "MSG",
      "msg_LocationDescRequired"
    ), // Location description is required!
    engAdd1Required: common.getLocalizedString("MSG", "msg_EngAdd1Required"), // English Address1 is required!
    engAdd2Required: common.getLocalizedString("MSG", "msg_EngAdd2Required"), // English Address2 is required!
    chiAdd1Required: common.getLocalizedString("MSG", "msg_ChiAdd1Required"), // Chinese Address1 is required!
    chiAdd2Required: common.getLocalizedString("MSG", "msg_ChiAdd2Required"), // Chinese Address2 is required!
    phNumRequired: common.getLocalizedString("MSG", "msg_PhNumRequired"), // Phone number is required!
    countryRequired: common.getLocalizedString("MSG", "msg_CountryRequired"), // Country is required!
    locationTypeRequired: common.getLocalizedString(
      "MSG",
      "msg_LocationTypeRequired"
    ), // Location type is required!
    dateClosedRequired: common.getLocalizedString(
      "MSG",
      "msg_DateClosedRequired"
    ), // Date closed is required!
    dateOpenRequired: common.getLocalizedString("MSG", "msg_DateOpenRequired"), // Date open is required!
    locationTypeDescRequired: common.getLocalizedString(
      "MSG",
      "msg_LocationTypeDescRequired"
    ), // Location type description is required!
    customerCategoryRequired: common.getLocalizedString(
      "MSG",
      "msg_CustomerCategoryRequired"
    ), // Customer category is required!
    customerCategoryDescRequired: common.getLocalizedString(
      "MSG",
      "msg_CustomerCategoryDescRequired"
    ), // Customer category description is required!
    priceClassRequired: common.getLocalizedString(
      "MSG",
      "msg_PriceClassRequired"
    ), // Price class is required!
    miscChrgCodeRequired: common.getLocalizedString(
      "MSG",
      "msg_MiscChrgCodeRequired"
    ), // Miscellaneous charge code is required!
    miscChrgDescRequired: common.getLocalizedString(
      "MSG",
      "msg_MiscChrgDescRequired"
    ), // Miscellaneous charge description is required!
    paymentTermCodeRequired: common.getLocalizedString(
      "MSG",
      "msg_PaymentTermCodeRequired"
    ), // Payment term code is required!
    paymentTermDescRequired: common.getLocalizedString(
      "MSG",
      "msg_PaymentTermDescRequired"
    ), // Payment term description is required!
    daysRequired: common.getLocalizedString("MSG", "msg_DaysRequired"), // Days is Required!
    dayMonthRequired: common.getLocalizedString("MSG", "msg_DayMonthRequired"), // Day month is required!
    countFromRequired: common.getLocalizedString(
      "MSG",
      "msg_CountFromRequired"
    ), // Count from is required!
    weightRequired: common.getLocalizedString("MSG", "msg_WeightRequired"), // Weight is required!
    retailTradeDiscRequired: common.getLocalizedString(
      "MSG",
      "msg_RetailTradeDiscRequired"
    ), // Retail trade discount is required!
    vendorTradeDiscRequired: common.getLocalizedString(
      "MSG",
      "msg_VendorTradeDiscRequired"
    ), // Vendor trade discount is required!
    priceClassCodeRequired: common.getLocalizedString(
      "MSG",
      "msg_PriceClassCodeRequired"
    ), // Price class code is required!
    priceClassDescRequired: common.getLocalizedString(
      "MSG",
      "msg_PriceClassDescRequired"
    ), // Price class description is required!
    GPRequired: common.getLocalizedString("MSG", "msg_GPRequired"), // GP is required!
    UDGP0Required: common.getLocalizedString("MSG", "msg_UDGP0Required"), // UDGP0 is required!
    UDGP1Required: common.getLocalizedString("MSG", "msg_UDGP1Required"), // UDGP1 is required!
    UDGP2Required: common.getLocalizedString("MSG", "msg_UDGP2Required"), // UDGP2 is required!
    UDGP3Required: common.getLocalizedString("MSG", "msg_UDGP3Required"), // UDGP3 is required!
    UDGP4Required: common.getLocalizedString("MSG", "msg_UDGP4Required"), // UDGP4 is required!
    txTypeRequired: common.getLocalizedString("MSG", "msg_TxTypeRequired"), //Transaction type is required!
    remarkCodeRequired: common.getLocalizedString(
      "MSG",
      "msg_RemarkCodeRequired"
    ), // Remark code is required!
    txRemarkRequired: common.getLocalizedString("MSG", "msg_TxRemarkRequired"), // Transaction remark is required!
    txPrfxRequired: common.getLocalizedString("MSG", "msg_TxPrfxRequired"), // Transaction prefix is required!
    maxNumRequired: common.getLocalizedString("MSG", "msg_MaxNumRequired"), // Maximum number is required!
    lastNumRequired: common.getLocalizedString("MSG", "msg_LastNumRequired"), // Last number is required!
    yrPrfxRequired: common.getLocalizedString("MSG", "msg_YrPrfxRequired"), // Year prefix is required!
    mthPrfxRequired: common.getLocalizedString("MSG", "msg_MthPrfxRequired"), //Month prefix is required!
    alwNegRequired: common.getLocalizedString("MSG", "msg_AlwNegRequired"), // Allow negative is required!
    curYrRequired: common.getLocalizedString("MSG", "msg_CurYrRequired"), // Current year is required!
    curPerRequired: common.getLocalizedString("MSG", "msg_CurPerRequired"), // CurPer is Required!
    txDescRequired: common.getLocalizedString("MSG", "msg_TxDescRequired"), // Transaction description is required!
    costCalSeqRequired: common.getLocalizedString(
      "MSG",
      "msg_CostCalSeqRequired"
    ), // Cost calculation sequence is required!
    entityNumRequired: common.getLocalizedString(
      "MSG",
      "msg_EntityNumRequired"
    ), // Entity number is required!
    unitCostRequired: common.getLocalizedString("MSG", "msg_UnitCostRequired"), // Unit cost is required!
    unitPriceRequired: common.getLocalizedString(
      "MSG",
      "msg_UnitPriceRequired"
    ), // Unit price is required!
    consignDateRequired: common.getLocalizedString(
      "MSG",
      "msg_ConsignDateRequired"
    ), // Consign date is required!
    seqRequired: common.getLocalizedString("MSG", "msg_SeqRequired"), // Sequence is required!
    barcodeRequired: common.getLocalizedString("MSG", "msg_BarcodeRequired"), // Barcode is required!
    pxClsRequired: common.getLocalizedString("MSG", "msg_PxClsRequired"), // Price class is required!
    effDateRequired: common.getLocalizedString("MSG", "msg_EffDateRequired"), // Effective date is required!
    UOMRequired: common.getLocalizedString("MSG", "msg_UOMRequired"), // UOM is required!
    dateModifyRequired: common.getLocalizedString(
      "MSG",
      "msg_DateModifyRequired"
    ), // Date modify is required!
    exchangeRateRequired: common.getLocalizedString(
      "MSG",
      "msg_ExchangeRateRequired"
    ), // Exchange rate is required!
    exchangeRateDigit: common.getLocalizedString(
      "MSG",
      "msg_ExchangeRateDigit"
    ), // Exchange rate must be numeric!
    txDateRequired: common.getLocalizedString("MSG", "msg_TxDateRequired"), // Transaction date is required!
    slsCodeRequired: common.getLocalizedString("MSG", "msg_SlsCodeRequired"), // Salesman is required!
    dateDueRequired: common.getLocalizedString("MSG", "msg_DateDueRequired"), // Date due is required!
    validDaysRequired: common.getLocalizedString(
      "MSG",
      "msg_ValidDaysRequired"
    ), // Valid Days is required!
    validDaysDigit: common.getLocalizedString("MSG", "msg_ValidDaysDigit"), // Valid Days must be numeric!
    qtyRequired: common.getLocalizedString("MSG", "msg_QtyRequired"), // Qty is required!
    minQtyRequired: function(params) {
      return common.formatString(
        common.getLocalizedString("MSG", "msg_MinQtyRequired"),
        params
      );
    }, // Qty value should be at least x!
    maxQtyExceed: function(params) {
      return common.formatString(
        common.getLocalizedString("MSG", "msg_maxQtyExceed"),
        params
      );
    }, // Qty value should be less than x!
    txSeqRequired: common.getLocalizedString("MSG", "msg_TxSeqRequired"), // Transaction sequence is required!
    itemDescriptionRequired: common.getLocalizedString(
      "MSG",
      "msg_ItemDescriptionRequired"
    ), // Item description is required!
    pcsCtnRequired: common.getLocalizedString("MSG", "msg_PcsCtnRequired"), // Pcs/Ctn is required!
    altUOMRequired: common.getLocalizedString("MSG", "msg_altUOMRequired"), // Alt_UOM is required!
    lineDiscountRequired: common.getLocalizedString(
      "MSG",
      "msg_LineDiscountRequired"
    ), // Line discount is required!
    chargeCodeRequired: common.getLocalizedString(
      "MSG",
      "msg_ChargeCodeRequired"
    ), // Charge code is required!
    chargeDescriptionRequired: common.getLocalizedString(
      "MSG",
      "msg_ChargeDescriptionRequired"
    ), // Charge description is required!
    chargeAmountRequired: common.getLocalizedString(
      "MSG",
      "msg_ChargeAmountRequired"
    ), // Charge amount is required!
    amountRequired: common.getLocalizedString("MSG", "msg_AmountRequired"), // Amount is required!
    ctnFrRequired: common.getLocalizedString("MSG", "msg_CtnFrRequired"), // Ctn Fr is required!
    ctnToRequired: common.getLocalizedString("MSG", "msg_CtnToRequired"), // Ctn To is required!
    errSaveInvoice: common.getLocalizedString("MSG", "msg_ErrSaveInvoice"), // Can't save invoice!
    invoicesavesuccess: common.getLocalizedString(
      "MSG",
      "msg_invoicesavesuccess"
    ), // Invoice saved successfully!
    invoicepostsuccess: common.getLocalizedString(
      "MSG",
      "msg_invoicepostsuccess"
    ),
    invoiceunpostsuccess: common.getLocalizedString(
      "MSG",
      "msg_invoiceunpostsuccess"
    ),
    goodsreceiveunpostsuccess: common.getLocalizedString(
      "MSG",
      "msg_goodsreceiveunpostsuccess"
    ),
    submitsettlementsuccess: common.getLocalizedString(
      "MSG",
      "msg_submitsettlementsuccess"
    ), // Submit Settlement Successfully!
    submitsettlementfail: common.getLocalizedString(
      "MSG",
      "msg_failsubmitsettlement"
    ), // fail to submit settlement!
    invUpdate: common.getLocalizedString("MSG", "msg_InvUpdate"), // Invoice updated successfully!
    invCopy: common.getLocalizedString("MSG", "msg_InvCopy"), // Invoice copied successfully!
    salesmanNameRequired: common.getLocalizedString(
      "MSG",
      "msg_SalesmanNameRequired"
    ), // Salesman name is required!
    confirmdeleteinv: common.getLocalizedString("MSG", "msg_confirmdeleteinv"), // Are you sure you want to delete the current Invoice?
    errSaveFailed: common.getLocalizedString("MSG", "msg_ErrSaveFailed"), // Save failed !
    errUpdateFailed: common.getLocalizedString("MSG", "msg_ErrUpdateRecord"), // Update failed !
    errDeleteFailed: common.getLocalizedString("MSG", "msg_RecordDeleteFail"), // Record deletion failed !
    errExportFail: common.getLocalizedString("MSG", "msg_ErrExportFail"), // Export failed !
    errLoginFail: common.getLocalizedString("MSG", "Login.CannotLogin"), // Login failed !
    poPost: common.getLocalizedString("MSG", "msg_POPost"), // PO posted successfully!
    poSubmit: common.getLocalizedString("MSG", "msg_POSubmit"), // PO submitted successfully!
    errPostPO: common.getLocalizedString("MSG", "msg_ErrPostInvoice"), // Can't post PO!
    errSubmitPO: common.getLocalizedString("MSG", "msg_ErrSubmitInvoice"), // Can't submit PO!
    postRecord: common.getLocalizedString("MSG", "msg_postRecord"), // Post the record
    submitRecord: common.getLocalizedString("MSG", "msg_submitRecord"), // Submit the record
    poApprove: common.getLocalizedString("MSG", "msg_POApprove"), // PO approved successfully!
    poReject: common.getLocalizedString("MSG", "msg_POReject"), // PO rejected successfully!
    errApprovePO: common.getLocalizedString("MSG", "msg_ErrApprovePO"), // Can't approve PO!
    errRejectPO: common.getLocalizedString("MSG", "msg_ErrRejectPO"), // Can't reject PO!
    approveRecord: common.getLocalizedString("MSG", "msg_approveRecord"), // Approve the record
    rejectRecord: common.getLocalizedString("MSG", "msg_rejectRecord"), // Reject the record
    locCodeRequired: common.getLocalizedString("MSG", "msg_locCodeRequired"), // Location code is required!
    recordPosted: common.getLocalizedString("MSG", "msg_RecordPosted"), // Record has been posted.
    errPostFailed: common.getLocalizedString("MSG", "msg_RecordPostFail"), // Record post failed !
    errUpostFailed: common.getLocalizedString("MSG", "msg_RecordUnpostFail"), // Record un-post failed !
    errInvoicePrintFailed: common.getLocalizedString(
      "MSG",
      "msg_ErrInvoicePrintFailed"
    ), // Print failed !
    errInvoicePrintPopupFailed: common.getLocalizedString(
      "MSG",
      "msg_ErrInvoicePrintPpopupFailed"
    ), // Popup not allowed in your browser !
    loginSuccess: common.getLocalizedString("MSG", "msg_LoginSuccess"), //You are successfullly logged in!
    errApproveInv: common.getLocalizedString("MSG", "msg_ErrApproveInv"), // Can't approve invoice!
    invApprove: common.getLocalizedString("MSG", "msg_InvApprove"), // Invoice approved!
    invReject: common.getLocalizedString("MSG", "msg_InvReject"), // Invoice rejected!
    errRejectInv: common.getLocalizedString("MSG", "msg_ErrRejectInv"), // Can't reject invoice!
    selectInvToApprove: common.getLocalizedString(
      "MSG",
      "msg_SelectInvToApprove"
    ), // Please select invoice to Approve
    selectInvToReject: common.getLocalizedString(
      "MSG",
      "msg_SelectInvToReject"
    ), // Please select invoice to reject
    errApproveSomeInvs: common.getLocalizedString(
      "MSG",
      "msg_ErrApproveSomeInvs"
    ), // some invoices fail to approve!
    errRejectSomeInvs: common.getLocalizedString(
      "MSG",
      "msg_ErrRejectSomeInvs"
    ), // some invoices fail to reject!
    noSelectionQtyAmt: common.getLocalizedString(
      "MSG",
      "msg_NoSelectionQtyAmt"
    ), // Please select at least one from Show Qty / Show Cost.
    salesOrdersavesuccess: common.getLocalizedString(
      "MSG",
      "msg_salesOrderSaveSuccess"
    ), // Sales Order Save Successfully.
    salesOrderUpdate: common.getLocalizedString("MSG", "msg_salesOrderUpdate"), // Sales Order Update Successfully.
    salesOrderCopy: common.getLocalizedString("MSG", "msg_salesOrderCopy"), // Sales Order Copy Successfully.
    errSaveSalesOrder: common.getLocalizedString(
      "MSG",
      "msg_errSaveSalesOrder"
    ), // Save Sales Order Failed !
    updateInvDateSuccess: common.getLocalizedString(
      "MSG",
      "msg_updateInvDateSuccess"
    ), // Invoice Date has been changed successfully!
    goodsReceiveDiscountRequired: common.getLocalizedString(
      "MSG",
      "msg_goodsReceiveDiscountRequired"
    ), // Goods receive discount Required !
    factoryRequired: common.getLocalizedString("MSG", "msg_FactoryRequired"), // Factory is required!
    vendorNumRequired: common.getLocalizedString(
      "MSG",
      "msg_ErrTempVendorNotEmpty"
    ), // Vendor cannot be blank !
    errSaveGoodsReceive: common.getLocalizedString(
      "MSG",
      "msg_ErrSaveGoodsReceive"
    ), // Save good receive failed !
    goodsReceivesavesuccess: common.getLocalizedString(
      "MSG",
      "msg_GoodsReceivesavesuccess"
    ), // Good receive saved successfully !
    goodsReceiveUpdatesuccess: common.getLocalizedString(
      "MSG",
      "msg_GoodsReceiveUpdateSuccess"
    ), // Good receive updated successfully !
    stockTransferadduccess: common.getLocalizedString(
      "MSG",
      "msg_stockTransferaddsuccess"
    ), //Stock Transfer Save Successfully

    stockTransferupdatesuccess: common.getLocalizedString(
      "MSG",
      "msg_stockTransferupdatesuccess"
    ), //Stock Transfer Update Successfully

    entnumempty: common.getLocalizedString("MSG", "msg_entnumempty"), //Please enter Entity Number
    nomail: common.getLocalizedString("MSG", "msg_nomail"), // Client email does not exists
    sendsummarysuccess: common.getLocalizedString(
      "MSG",
      "msg_sendsummarysuccess"
    ), // Send Summary Success
    sendsummaryfail: common.getLocalizedString("MSG", "msg_sendsummaryfail"), // Fail to Send Summary

    goodsReceivepostsuccess: common.getLocalizedString(
      "MSG",
      "msg_GoodsReceivePostSuccess"
    ), // Good receive Post successfully !

    entitysavesuccess: common.getLocalizedString(
      "MSG",
      "msg_EntitySaveSuccess"
    ), // Entity Save Successfully !

    entitydeletesuccess: common.getLocalizedString(
      "MSG",
      "msg_EntityDeleteSuccess"
    ), // Entity Deleted Successfully !

    errSaveEntity: common.getLocalizedString("MSG", "msg_EntityFailed"), // Save Entity Failed !

    //BECustomer
    CustCateRequired: common.getLocalizedString("MSG", "msg_CustCateRequired"), // Customer Category is required!
    vencodeRequired: common.getLocalizedString("MSG", "msg_vencodeRequired"), // Vendor Category is required!
    englishNameRequired: common.getLocalizedString(
      "MSG",
      "msg_engNameRequired"
    ), // English Name is required!
    chineseNameRequired: common.getLocalizedString(
      "MSG",
      "msg_chiNameRequired"
    ), // Chinese Name is required!
    contactsRequired: common.getLocalizedString("MSG", "msg_contactsRequired"), // Contacts required!
    brNumberRequired: common.getLocalizedString("MSG", "msg_brNumberRequired"), // BRNumber is required!
    curcodeRequired: common.getLocalizedString("MSG", "msg_curcodeRequired"), // CurrencyCode is required!
    offAddCodeRequired: common.getLocalizedString(
      "MSG",
      "msg_offAddCodeRequired"
    ), // Office Address Code is required!
    delAddCodeRequired: common.getLocalizedString(
      "MSG",
      "msg_delAddCodeRequired"
    ), // Delivery Address Code is required!
    CrLmtRequired: common.getLocalizedString("MSG", "msg_CrLmtRequired"), // Credit Limit is required!
    AcBalRequired: common.getLocalizedString("MSG", "msg_AcBalRequired"), // Acct Balance is required!
    payTemRequired: common.getLocalizedString("MSG", "msg_payTemRequired"), // PayTerm is required!
    buyerIdRequired: common.getLocalizedString("MSG", "msg_buyerIdRequired"), // Buyer ID is required!
    allocSeqRequired: common.getLocalizedString("MSG", "msg_allocSeqRequired"), // Goods Allocation Seque is required!
    acNumRequired: common.getLocalizedString("MSG", "msg_acNumRequired"), // Acct Numner is required!
    ref1Required: common.getLocalizedString("MSG", "msg_ref1Required"), // Reference 1 is required!
    ref2Required: common.getLocalizedString("MSG", "msg_ref2Required"), // Reference 2 is required!
    ref3Required: common.getLocalizedString("MSG", "msg_ref3Required"), // Reference 3 is required!

    //BELocation
    EntityLocationRequired: common.getLocalizedString(
      "MSG",
      "msg_EntityLocationRequired"
    ), // Entity Location is required!
    entloc_langRequired: common.getLocalizedString(
      "MSG",
      "msg_entloc_langRequired"
    ), // Language is required!
    entloc_countryRequired: common.getLocalizedString(
      "MSG",
      "msg_entloc_countryRequired"
    ), // Country is required!
    entloc_distRequired: common.getLocalizedString(
      "MSG",
      "msg_entloc_distRequired"
    ), // District is required!
    entloc_areaRequired: common.getLocalizedString(
      "MSG",
      "msg_entloc_areaRequired"
    ), // Area is required!
    entloc_mobRequired: common.getLocalizedString(
      "MSG",
      "msg_entloc_mobRequired"
    ), // Mobile Number is required!
    entloc_pagerRequired: common.getLocalizedString(
      "MSG",
      "msg_entloc_pagerRequired"
    ), // Pager is required!
    entloc_AllocSeqRequired: common.getLocalizedString(
      "MSG",
      "msg_entloc_AllocSeqRequired"
    ), // Allocation Seq. is required!
    entloc_RemarkRequired: common.getLocalizedString(
      "MSG",
      "msg_entloc_RemarkRequired"
    ), // Remark is required!

    //22-09-2020
    userGrpRequired: common.getLocalizedString("MSG", "msg_userGrpRequired"), // User Group is required!
    menuIdRequired: common.getLocalizedString("MSG", "msg_menuIdRequired"), // MenuId is required!
    userGroupIdRequired: common.getLocalizedString(
      "MSG",
      "msg_userGroupIdRequired"
    ), // User GroupID is required!
    userGroupDescRequired: common.getLocalizedString(
      "MSG",
      "msg_userGroupDescRequired"
    ), // User Group Description is required!
    selectUserGrp: common.getLocalizedString("MSG", "msg_selectUserGrp"), // Please Select User Group!
    useridRequired: common.getLocalizedString("MSG", "msg_useridRequired"), // User ID is Required!
    usernameRequired: common.getLocalizedString("MSG", "msg_usernameRequired"), // User Name is Required!
    emailRequired: common.getLocalizedString("MSG", "msg_emailRequired"), // Email is Required!
    DefaultPathRequired: common.getLocalizedString(
      "MSG",
      "msg_DefaultPathRequired"
    ), // DefaultPath is Required!
    SupervisorRequired: common.getLocalizedString(
      "MSG",
      "msg_SupervisorRequired"
    ), // Supervisor is Required!
    WinADNameRequired: common.getLocalizedString(
      "MSG",
      "msg_WinADNameRequired"
    ), // WinADName is Required!
    PasswordRequired: common.getLocalizedString("MSG", "msg_PasswordRequired"), // Password is Required!
    ReTypePasswordRequired: common.getLocalizedString(
      "MSG",
      "msg_ReTypePasswordRequired"
    ), // ReType Password is Required!
    noEditSelection: common.getLocalizedString("MSG", "msg_noEditSelection"), // Please select at least one record for Update!
    useridexists: common.getLocalizedString("MSG", "msg_useridexists"), // UserID Exists!
    errCurRate: common.getLocalizedString("MSG", "msg_errCurRate"), // EffectiveDate and ExchangeRate are Required!
    errPeriodStartDtEndDt: common.getLocalizedString(
      "MSG",
      "msg_errPeriodStartDtEndDt"
    ), // Period,Start Date and End Date are Required!
    yearRequired: common.getLocalizedString("MSG", "msg_yearRequired"), // Please Enter Year!

    charCodeRequired: common.getLocalizedString("MSG", "msg_charCodeRequired"), // Character Code is Required!
    charDescRequired: common.getLocalizedString("MSG", "msg_charDescRequired"), // Character Description is Required!

    //2020-07-12
    errEnterAddress: common.getLocalizedString("MSG", "msg_errEnterAddress"), // Please Enter Address.
    locaddedtothelist: common.getLocalizedString(
      "MSG",
      "msg_locaddedtothelist"
    ), // Location added to the List!
    locupdatedtothelist: common.getLocalizedString(
      "MSG",
      "msg_locupdatedtothelist"
    ), // Location updated to the List!
    errEnterCustorVen: common.getLocalizedString(
      "MSG",
      "msg_errEnterCustorVen"
    ), // Please Enter Customer Or Vendor Details.
    recordexists: common.getLocalizedString("MSG", "msg_recordexists"), // Record already Exists!

    vendorCategoryRequired: common.getLocalizedString(
      "MSG",
      "msg_vendorCategoryRequired"
    ), // Vendor Category is Required!
    vendorCategoryDescRequired: common.getLocalizedString(
      "MSG",
      "msg_vendorCategoryDescRequired"
    ), // Vendor Category Description is Required!
    errEnterLocation: common.getLocalizedString("MSG", "msg_errEnterLocation"), // Please Enter Location.
    errEntNumExist: common.getLocalizedString("MSG", "msg_errEntNumExist"), // Entity Number already Exists!
    errEntNumnotExist: common.getLocalizedString(
      "MSG",
      "msg_errEntNumnotExist"
    ), // Entity Number does not Exists!

    orderNumberMessage: common.getLocalizedString(
      "MSG",
      "msg_orderNumberMessage"
    ), // Your order number is ...
    passwordUpdated: common.getLocalizedString("MSG", "msg_passwordUpdated"), // Your password has been updated.
    cancelOrderConfirmation: common.getLocalizedString(
      "MSG",
      "msg_cancelOrderConfirmation"
    ), // Your password has been updated.
    cannotdelete: common.getLocalizedString("MSG", "msg_cannotdelete"), // This user is supervisor, so can not delete.
    confirmdeleteEnt: common.getLocalizedString("MSG", "msg_confirmdeleteEnt"), // Are you sure you want to delete Entity?

    cannotDeleteUsergrp: common.getLocalizedString(
      "MSG",
      "msg_cannotDeleteUsergrp"
    ), // Records are in use, so can not delete records.
    errInvalidDateRange: common.getLocalizedString(
      "MSG",
      "msg_errInvalidDateRange"
    ), // Invalid Date Range!From Date cannot be after To Date!
    savesuccess: common.getLocalizedString("MSG", "msg_savesuccess"), // Save Successfully!
    noSelectionOrChkDate: common.getLocalizedString(
      "MSG",
      "msg_noSelectionOrChkDate"
    ), // Please select at least one record Or Check Invocie Date!
    sysparamsavesuccess: common.getLocalizedString(
      "MSG",
      "msg_sysparamsavesuccess"
    ), // Parameter Save Successfully !
    qtyAdjustmentsavesuccess: common.getLocalizedString(
      "MSG",
      "msg_qtyAdjustmentsavesuccess"
    ), // Qty Adjustment Save Successfully !
    costAdjustmentsavesuccess: common.getLocalizedString(
      "MSG",
      "msg_costAdjustmentsavesuccess"
    ), // Cost Adjustment Save Successfully !

    errSaveSR: common.getLocalizedString("MSG", "msg_errSaveSR"), // Can't save Sales Return!
    salesReturnSaveSuccess: common.getLocalizedString(
      "MSG",
      "msg_salesReturnSaveSuccess"
    ), // Sales Return saved successfully!
    srUpdate: common.getLocalizedString("MSG", "msg_srUpdate"), // Sales Return updated successfully!

    srApprove: common.getLocalizedString("MSG", "msg_srApprove"), // Sales Return approved successfully!
    srReject: common.getLocalizedString("MSG", "msg_srReject"), // Sales Return rejected successfully!
    errApproveSR: common.getLocalizedString("MSG", "msg_ErrApproveSR"), // Can't approve Sales Return!
    errRejectSR: common.getLocalizedString("MSG", "msg_ErrRejectSR"), // Can't reject Sales Return!

    bundleCodeRequired: common.getLocalizedString(
      "MSG",
      "msg_bundleCodeRequired"
    ), // Bundle Code Required!
    descRequired: common.getLocalizedString("MSG", "msg_descRequired"), // Description Required!
    errItemNumnotExist: common.getLocalizedString(
      "MSG",
      "msg_ErrItemNumNotExist"
    ), // Item Number does not Exists!
    idRequired: common.getLocalizedString("MSG", "msg_idRequired"), // Id Required!
    amtRequired: common.getLocalizedString("MSG", "msg_amtRequired"), // Amount Required!
    typeRequired: common.getLocalizedString("MSG", "msg_typeRequired"), // Type Required!
    valueRequired: common.getLocalizedString("MSG", "msg_valueRequired"), // Value Required!
    errItemNumExist: common.getLocalizedString("MSG", "msg_ErrItemNumExist"), // Item Number already Exists!
    soConvertedintoInv: common.getLocalizedString(
      "MSG",
      "msg_soConvertedintoInv"
    ), // SO Converted into Invoice Successfully!
    selectonerecord: common.getLocalizedString("MSG", "msg_selectonerecord"), // Please select at least one Record!
    successConverted: common.getLocalizedString("MSG", "msg_successConverted"), // Successfully Converted
    notConverted: common.getLocalizedString("MSG", "msg_notConverted"), // Successfully Not Converted
    selectOneLabel: common.getLocalizedString("MSG", "msg_SelectOneLabel"), // select one label
    unsave: common.getLocalizedString("MSG", "msg_unsave"), // Record is not saved yet, sure to reset?
    insertRejectReason: common.getLocalizedString("MSG", "insertRejectReason"), // Please insert Reject Reason
    insertApproveReason: common.getLocalizedString(
      "MSG",
      "insertApproveReason"
    ), // Please insert Approve Reason
    errNoReason: common.getLocalizedString("MSG", "msg_errNoReason"), // You must insert a reason
    addProductSuccess: common.getLocalizedString(
      "MSG",
      "msg_addProductSuccess"
    ), // You must insert a reason
    plzReSel: common.getLocalizedString("MSG", "msg_plzReSel"), // Please re-select!
    genConfirmMsg: common.getLocalizedString("MSG", "genConfirmMsg"), //Want to generate SO or Mold SO?
    printFail: common.getLocalizedString("MSG", "printFail")
  },
  Title: {
    salesanalysisbyfiscalper: common.getLocalizedString(
      "TITLE",
      "salesanalysisbyfiscalper"
    ), //Sales Analysis By Fiscal Period
    stockvaluebybrand: common.getLocalizedString("TITLE", "stockvaluebybrand"), //Stock Value By Brand
    stockvaluebycate1: common.getLocalizedString("TITLE", "stockvaluebycate1"), //Stock Value By Cate1
    salesanalysisbycustcate: common.getLocalizedString(
      "TITLE",
      "salesanalysisbycustcate"
    ), //Sales Analysis By Cust Cate
    salesanalysisbysalesman: common.getLocalizedString(
      "TITLE",
      "salesanalysisbysalesman"
    ), //Sales Analysis By Salesman
    salesanalysisbycate1: common.getLocalizedString(
      "TITLE",
      "salesanalysisbycate1"
    ), //Sales Analysis By Cate1
    TxTypeAnnualComparison: common.getLocalizedString(
      "TITLE",
      "TxTypeAnnualComparison"
    ), //订单类型年度对比
    TxTypeMonthlyComparison: common.getLocalizedString(
      "TITLE",
      "TxTypeMonthlyComparison"
    ), //订单类型月度对比
    LocAnnualComparison: common.getLocalizedString(
      "TITLE",
      "LocAnnualComparison"
    ), //店铺总销量对比去年同期
    TxItemTopN: common.getLocalizedString("TITLE", "TxItemTopN"), // Top 10 transaction amount (by item) 交易金额排名前十的品牌
    TxBrandTopN: common.getLocalizedString("TITLE", "TxBrandTopN"), // Top 10 transaction amount (by brand) 交易金额排名前十的品牌
    ShopAnnualComparison: common.getLocalizedString(
      "TITLE",
      "ShopAnnualComparison"
    ), //商品销量对比去年同期
    newOrder: common.getLocalizedString("TITLE", "newOrder"), // New Order
    orderStatus: common.getLocalizedString("TITLE", "orderStatus"), // Order Status
    orderConfirmation: common.getLocalizedString("TITLE", "orderConfirmation"), // Order Confirmation
    addNewChildItem: common.getLocalizedString("TITLE", "addNewChildItem"), // Add New Child Item
    editCurItem: common.getLocalizedString("TITLE", "editCurItem") // Edit Current Item
  },
  Common: {
    msgSureDeleteItem: common.getLocalizedString(
      "COMMON",
      "Common.msgSureDeleteItem"
    ), // Are you sure you want to delete this record ?
    msgSurePostItem: common.getLocalizedString(
      "COMMON",
      "Common.msgSurePostItem"
    ), // Are you sure you want to post this record ?
    msgSureSubmitItem: common.getLocalizedString(
      "COMMON",
      "Common.msgSureSubmitItem"
    ), // Are you sure you want to submit this record ?
    msgSureApproveItem: common.getLocalizedString(
      "COMMON",
      "Common.msgSureApproveItem"
    ), // Are you sure you want to approve
    msgSureRejectItem: common.getLocalizedString(
      "COMMON",
      "Common.msgSureRejectItem"
    ), // Are you sure you want to reject
    msgSure: common.getLocalizedString("COMMON", "Common.msgSure") // Are you sure?
  }
};
